/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.12
 */
import * as reactQuery from '@tanstack/react-query'
import { V3ApiContext, useV3ApiContext } from './v3ApiContext'
import type * as Fetcher from './v3ApiFetcher'
import { v3ApiFetch } from './v3ApiFetcher'
import type * as Schemas from './v3ApiSchemas'

export type PostClusterPathParams = {
  orgId: string
}

export type PostClusterError = Fetcher.ErrorWrapper<undefined>

export type PostClusterVariables = {
  body: Schemas.ClusterUpdate
  pathParams: PostClusterPathParams
} & V3ApiContext['fetcherOptions']

export const fetchPostCluster = (
  variables: PostClusterVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClusterCreationRevisionResponse,
    PostClusterError,
    Schemas.ClusterUpdate,
    {},
    {},
    PostClusterPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters',
    method: 'post',
    ...variables,
    signal,
  })

export const usePostCluster = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ClusterCreationRevisionResponse,
      PostClusterError,
      PostClusterVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ClusterCreationRevisionResponse,
    PostClusterError,
    PostClusterVariables
  >({
    mutationFn: (variables: PostClusterVariables) =>
      fetchPostCluster({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type PatchOrganisationFeaturesPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type PatchOrganisationFeaturesError = Fetcher.ErrorWrapper<undefined>

export type PatchOrganisationFeaturesVariables = {
  body?: Schemas.OrganisationFeatures
  pathParams: PatchOrganisationFeaturesPathParams
} & V3ApiContext['fetcherOptions']

export const fetchPatchOrganisationFeatures = (
  variables: PatchOrganisationFeaturesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.OrganisationFeatures,
    PatchOrganisationFeaturesError,
    Schemas.OrganisationFeatures,
    {},
    {},
    PatchOrganisationFeaturesPathParams
  >({
    url: '/api/v3/orgs/{orgId}/features',
    method: 'patch',
    ...variables,
    signal,
  })

export const usePatchOrganisationFeatures = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.OrganisationFeatures,
      PatchOrganisationFeaturesError,
      PatchOrganisationFeaturesVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.OrganisationFeatures,
    PatchOrganisationFeaturesError,
    PatchOrganisationFeaturesVariables
  >({
    mutationFn: (variables: PatchOrganisationFeaturesVariables) =>
      fetchPatchOrganisationFeatures({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetOrganisationFeaturesPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type GetOrganisationFeaturesError = Fetcher.ErrorWrapper<undefined>

export type GetOrganisationFeaturesVariables = {
  pathParams: GetOrganisationFeaturesPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Retrieve all features for the organization
 */
export const fetchGetOrganisationFeatures = (
  variables: GetOrganisationFeaturesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.OrganisationFeatures,
    GetOrganisationFeaturesError,
    undefined,
    {},
    {},
    GetOrganisationFeaturesPathParams
  >({
    url: '/api/v3/orgs/{orgId}/features',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Retrieve all features for the organization
 */
export const useGetOrganisationFeatures = <
  TData = Schemas.OrganisationFeatures,
>(
  variables: GetOrganisationFeaturesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.OrganisationFeatures,
      GetOrganisationFeaturesError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.OrganisationFeatures,
    GetOrganisationFeaturesError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/features',
      operationId: 'getOrganisationFeatures',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetOrganisationFeatures({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type RenameOrganisationPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type RenameOrganisationError = Fetcher.ErrorWrapper<undefined>

export type RenameOrganisationVariables = {
  body: Schemas.OrganisationName
  pathParams: RenameOrganisationPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Renames the organisation through the same apicultor operation as the console's
 * `PUT /api/v2/orgs/{orgId}/name`: the name is updated in the cloud database and propagated to
 * hivemq-account-service. Propagation is best-effort, as in the console, so a failed propagation
 * does not fail the request.
 *
 * Every rename that reaches apicultor is recorded in the audit log with action
 * `organization:rename`, the previous name, the new name and the outcome.
 */
export const fetchRenameOrganisation = (
  variables: RenameOrganisationVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.OrganisationName,
    RenameOrganisationError,
    Schemas.OrganisationName,
    {},
    {},
    RenameOrganisationPathParams
  >({ url: '/api/v3/orgs/{orgId}/name', method: 'put', ...variables, signal })

/**
 * Renames the organisation through the same apicultor operation as the console's
 * `PUT /api/v2/orgs/{orgId}/name`: the name is updated in the cloud database and propagated to
 * hivemq-account-service. Propagation is best-effort, as in the console, so a failed propagation
 * does not fail the request.
 *
 * Every rename that reaches apicultor is recorded in the audit log with action
 * `organization:rename`, the previous name, the new name and the outcome.
 */
export const useRenameOrganisation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.OrganisationName,
      RenameOrganisationError,
      RenameOrganisationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.OrganisationName,
    RenameOrganisationError,
    RenameOrganisationVariables
  >({
    mutationFn: (variables: RenameOrganisationVariables) =>
      fetchRenameOrganisation({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetAddonUsagePathParams = {
  /**
   * Organisation ID
   */
  orgId: string
  /**
   * Add-on ID. Only `data_intelligence` is implemented; any other value is `404`.
   */
  addonId: string
}

export type GetAddonUsageError = Fetcher.ErrorWrapper<undefined>

export type GetAddonUsageVariables = {
  pathParams: GetAddonUsagePathParams
} & V3ApiContext['fetcherOptions']

/**
 * Reads the organisation's `{addonId}` add-on subscription live from Stripe and returns its
 * Billing Meter readings for the current billing period — current billing period only, no
 * historical trend, and no real-time broker telemetry (this reflects whatever the usage
 * reporting job's last nightly run reported).
 *
 * **Only `data_intelligence` is implemented today.** The path is addon-keyed (matching
 * `features.addons`'s own addon-ID-keyed shape) rather than hardcoding `data_intelligence` in
 * the route, and an `addonId` with no handler behind it is `404`. The response shape is
 * add-on-agnostic — a second addon would need its own handler, which knows how to read its
 * subscription, but not its own schema.
 *
 * Requires an `{addonId}` entry with a `subscriptionId` in `features.addons`; absent either,
 * the response is `404`. `meters` is keyed by each subscription item's price
 * `metadata.addonMeterEventName`, so no meter name is hardcoded: an item carrying no event
 * name or no `recurring.meter` is skipped and logged rather than failing the request, and a
 * meter that is not on the subscription is absent from the map rather than reported as `0`.
 * `freeAllowances` is every subscription metadata entry whose key starts with
 * `freeAllowance`, reported under Stripe's own key names.
 *
 * For a non-canceled subscription the window is `[currentPeriodStart, now]`; for a
 * `canceled` subscription it is clamped to `[currentPeriodStart, currentPeriodEnd]` of the
 * last billing period and is not extended to now.
 *
 * A Stripe failure (subscription retrieval or any meter read) is `502`, never a silent
 * default reading.
 */
export const fetchGetAddonUsage = (
  variables: GetAddonUsageVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.AddonUsage,
    GetAddonUsageError,
    undefined,
    {},
    {},
    GetAddonUsagePathParams
  >({
    url: '/api/v3/orgs/{orgId}/addons/{addonId}/usage',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Reads the organisation's `{addonId}` add-on subscription live from Stripe and returns its
 * Billing Meter readings for the current billing period — current billing period only, no
 * historical trend, and no real-time broker telemetry (this reflects whatever the usage
 * reporting job's last nightly run reported).
 *
 * **Only `data_intelligence` is implemented today.** The path is addon-keyed (matching
 * `features.addons`'s own addon-ID-keyed shape) rather than hardcoding `data_intelligence` in
 * the route, and an `addonId` with no handler behind it is `404`. The response shape is
 * add-on-agnostic — a second addon would need its own handler, which knows how to read its
 * subscription, but not its own schema.
 *
 * Requires an `{addonId}` entry with a `subscriptionId` in `features.addons`; absent either,
 * the response is `404`. `meters` is keyed by each subscription item's price
 * `metadata.addonMeterEventName`, so no meter name is hardcoded: an item carrying no event
 * name or no `recurring.meter` is skipped and logged rather than failing the request, and a
 * meter that is not on the subscription is absent from the map rather than reported as `0`.
 * `freeAllowances` is every subscription metadata entry whose key starts with
 * `freeAllowance`, reported under Stripe's own key names.
 *
 * For a non-canceled subscription the window is `[currentPeriodStart, now]`; for a
 * `canceled` subscription it is clamped to `[currentPeriodStart, currentPeriodEnd]` of the
 * last billing period and is not extended to now.
 *
 * A Stripe failure (subscription retrieval or any meter read) is `502`, never a silent
 * default reading.
 */
export const useGetAddonUsage = <TData = Schemas.AddonUsage>(
  variables: GetAddonUsageVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.AddonUsage, GetAddonUsageError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<Schemas.AddonUsage, GetAddonUsageError, TData>({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/addons/{addonId}/usage',
      operationId: 'getAddonUsage',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAddonUsage({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type ReonboardPulseError = Fetcher.ErrorWrapper<undefined>

export type ReonboardPulseVariables = {
  body: Schemas.PulseReonboardRequest
} & V3ApiContext['fetcherOptions']

/**
 * Operator action that re-triggers Pulse provisioning for one or a small batch of
 * already-onboarded organisations. Per org, apicultor blanks `features.pulse.pulseServerId`
 * (if set) then calls the account-service reprovision endpoint, returning a per-org outcome.
 *
 * Caveats: a `reprovisioned` outcome means onboarding events were *enqueued* — delivery honours
 * account-service's `EVENTS_SNS_ENABLED` kill-switch (enabled in staging and prod).
 * `pulseServerId` repopulates asynchronously via Pulse's round-trip, and Pulse may assign a
 * different server than before.
 *
 * For an organisation that has **no project**, the call is not reversible: account-service
 * creates a `Default project` and Pulse mints a project for it, and neither can be undone. That
 * path requires account-service at or past spec 022 — against an older deployment the blank
 * still lands but nothing is emitted, leaving the organisation with no `pulseServerId` until the
 * call is repeated. Re-running is otherwise safe: blanking is idempotent.
 */
export const fetchReonboardPulse = (
  variables: ReonboardPulseVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.PulseReonboardReport,
    ReonboardPulseError,
    Schemas.PulseReonboardRequest,
    {},
    {},
    {}
  >({ url: '/api/v3/pulse/reonboard', method: 'post', ...variables, signal })

/**
 * Operator action that re-triggers Pulse provisioning for one or a small batch of
 * already-onboarded organisations. Per org, apicultor blanks `features.pulse.pulseServerId`
 * (if set) then calls the account-service reprovision endpoint, returning a per-org outcome.
 *
 * Caveats: a `reprovisioned` outcome means onboarding events were *enqueued* — delivery honours
 * account-service's `EVENTS_SNS_ENABLED` kill-switch (enabled in staging and prod).
 * `pulseServerId` repopulates asynchronously via Pulse's round-trip, and Pulse may assign a
 * different server than before.
 *
 * For an organisation that has **no project**, the call is not reversible: account-service
 * creates a `Default project` and Pulse mints a project for it, and neither can be undone. That
 * path requires account-service at or past spec 022 — against an older deployment the blank
 * still lands but nothing is emitted, leaving the organisation with no `pulseServerId` until the
 * call is repeated. Re-running is otherwise safe: blanking is idempotent.
 */
export const useReonboardPulse = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PulseReonboardReport,
      ReonboardPulseError,
      ReonboardPulseVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.PulseReonboardReport,
    ReonboardPulseError,
    ReonboardPulseVariables
  >({
    mutationFn: (variables: ReonboardPulseVariables) =>
      fetchReonboardPulse({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetSalesforceAccountPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type GetSalesforceAccountError = Fetcher.ErrorWrapper<undefined>

export type GetSalesforceAccountVariables = {
  pathParams: GetSalesforceAccountPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Returns the `salesforceAccountId` stored in hivemq-account-service for this organisation
 * (null when unlinked). account-service is the **sole store** of this value — there is no
 * cloud-side column, cache, or copy — so this is a read-through on every call and the value is
 * never persisted cloud-side.
 *
 * A disabled account-service client returns `503` rather than `linked: false`: "unlinked" and
 * "we could not ask" are materially different answers to an operator deciding whether to bind a
 * commercial account, and conflating them would invite a wrong link.
 */
export const fetchGetSalesforceAccount = (
  variables: GetSalesforceAccountVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.SalesforceAccountLink,
    GetSalesforceAccountError,
    undefined,
    {},
    {},
    GetSalesforceAccountPathParams
  >({
    url: '/api/v3/orgs/{orgId}/salesforce-account',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the `salesforceAccountId` stored in hivemq-account-service for this organisation
 * (null when unlinked). account-service is the **sole store** of this value — there is no
 * cloud-side column, cache, or copy — so this is a read-through on every call and the value is
 * never persisted cloud-side.
 *
 * A disabled account-service client returns `503` rather than `linked: false`: "unlinked" and
 * "we could not ask" are materially different answers to an operator deciding whether to bind a
 * commercial account, and conflating them would invite a wrong link.
 */
export const useGetSalesforceAccount = <TData = Schemas.SalesforceAccountLink>(
  variables: GetSalesforceAccountVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SalesforceAccountLink,
      GetSalesforceAccountError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.SalesforceAccountLink,
    GetSalesforceAccountError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/salesforce-account',
      operationId: 'getSalesforceAccount',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetSalesforceAccount({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type SetSalesforceAccountPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type SetSalesforceAccountError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Schemas.SalesforceAccountLinkResult
    }
  | {
      status: 404
      payload: Schemas.SalesforceAccountLinkResult
    }
  | {
      status: 409
      payload: Schemas.SalesforceAccountLinkResult
    }
  | {
      status: 502
      payload: Schemas.SalesforceAccountLinkResult
    }
  | {
      status: 503
      payload: Schemas.SalesforceAccountLinkResult
    }
>

export type SetSalesforceAccountVariables = {
  body: Schemas.SalesforceAccountLinkRequest
  pathParams: SetSalesforceAccountPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Sets the organisation's Salesforce account link via apicultor → account-service
 * `PUT /api/v1/organizations/{organizationId}/salesforce-account`.
 *
 * A first link succeeds (`linked`), re-submitting the same value is idempotent and skips the
 * write (`unchanged`), and submitting a *different* value never silently overwrites. A rebind
 * requires BOTH a matching `expectedCurrentSalesforceAccountId` and a non-blank `reason`;
 * without them the request is refused with `409 confirmation_required` and the stored value is
 * echoed back as `previousSalesforceAccountId` so the caller can present an informed
 * confirmation. A correctly confirmed rebind returns `200 rebound`.
 *
 * The confirm token is a compare-and-swap: account-service evaluates it inside its row lock
 * (spec `017-salesforce-rebind-cas`), so it is the authoritative guard — the cloud-side check
 * exists to supply `previousSalesforceAccountId` and to distinguish "you did not confirm" from
 * "your token was stale", neither of which upstream's `409` conveys.
 *
 * A `409 conflict` on a *confirmed* rebind means the stored value changed underneath you (or,
 * during rollout, that this environment's account-service predates CAS support): re-read the
 * current value and retry.
 */
export const fetchSetSalesforceAccount = (
  variables: SetSalesforceAccountVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.SalesforceAccountLinkResult,
    SetSalesforceAccountError,
    Schemas.SalesforceAccountLinkRequest,
    {},
    {},
    SetSalesforceAccountPathParams
  >({
    url: '/api/v3/orgs/{orgId}/salesforce-account',
    method: 'put',
    ...variables,
    signal,
  })

/**
 * Sets the organisation's Salesforce account link via apicultor → account-service
 * `PUT /api/v1/organizations/{organizationId}/salesforce-account`.
 *
 * A first link succeeds (`linked`), re-submitting the same value is idempotent and skips the
 * write (`unchanged`), and submitting a *different* value never silently overwrites. A rebind
 * requires BOTH a matching `expectedCurrentSalesforceAccountId` and a non-blank `reason`;
 * without them the request is refused with `409 confirmation_required` and the stored value is
 * echoed back as `previousSalesforceAccountId` so the caller can present an informed
 * confirmation. A correctly confirmed rebind returns `200 rebound`.
 *
 * The confirm token is a compare-and-swap: account-service evaluates it inside its row lock
 * (spec `017-salesforce-rebind-cas`), so it is the authoritative guard — the cloud-side check
 * exists to supply `previousSalesforceAccountId` and to distinguish "you did not confirm" from
 * "your token was stale", neither of which upstream's `409` conveys.
 *
 * A `409 conflict` on a *confirmed* rebind means the stored value changed underneath you (or,
 * during rollout, that this environment's account-service predates CAS support): re-read the
 * current value and retry.
 */
export const useSetSalesforceAccount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SalesforceAccountLinkResult,
      SetSalesforceAccountError,
      SetSalesforceAccountVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.SalesforceAccountLinkResult,
    SetSalesforceAccountError,
    SetSalesforceAccountVariables
  >({
    mutationFn: (variables: SetSalesforceAccountVariables) =>
      fetchSetSalesforceAccount({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type ClearSalesforceAccountPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type ClearSalesforceAccountError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Schemas.SalesforceAccountLinkResult
    }
  | {
      status: 404
      payload: Schemas.SalesforceAccountLinkResult
    }
  | {
      status: 409
      payload: Schemas.SalesforceAccountLinkResult
    }
  | {
      status: 502
      payload: Schemas.SalesforceAccountLinkResult
    }
  | {
      status: 503
      payload: Schemas.SalesforceAccountLinkResult
    }
>

export type ClearSalesforceAccountVariables = {
  body: Schemas.SalesforceAccountUnlinkRequest
  pathParams: ClearSalesforceAccountPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Clears the organisation's Salesforce account link, guarded by the same compare-and-swap rule
 * as the link endpoint: **any operation that changes an existing link must name the current
 * value** via `expectedCurrentSalesforceAccountId`. Unlinking the wrong org is not a harmless
 * empty field — account-service is the sole store, so it destroys the only copy of the answer.
 *
 * A correctly confirmed unlink clears the link and returns `200 unlinked`. An absent or
 * mismatched token on a linked org is refused with `409 confirmation_required`, echoing the
 * stored value as `previousSalesforceAccountId`. An already-unlinked org returns `200 unchanged`
 * without any upstream call, and an unknown org `404 not_found`.
 *
 * The confirm token is a compare-and-swap: account-service evaluates it inside the same row lock
 * as the link endpoint (spec `018-salesforce-unlink-cas`), so it is the authoritative guard.
 *
 * A blank `reason` is rejected with `400` *before* any of the above.
 */
export const fetchClearSalesforceAccount = (
  variables: ClearSalesforceAccountVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.SalesforceAccountLinkResult,
    ClearSalesforceAccountError,
    Schemas.SalesforceAccountUnlinkRequest,
    {},
    {},
    ClearSalesforceAccountPathParams
  >({
    url: '/api/v3/orgs/{orgId}/salesforce-account',
    method: 'delete',
    ...variables,
    signal,
  })

/**
 * Clears the organisation's Salesforce account link, guarded by the same compare-and-swap rule
 * as the link endpoint: **any operation that changes an existing link must name the current
 * value** via `expectedCurrentSalesforceAccountId`. Unlinking the wrong org is not a harmless
 * empty field — account-service is the sole store, so it destroys the only copy of the answer.
 *
 * A correctly confirmed unlink clears the link and returns `200 unlinked`. An absent or
 * mismatched token on a linked org is refused with `409 confirmation_required`, echoing the
 * stored value as `previousSalesforceAccountId`. An already-unlinked org returns `200 unchanged`
 * without any upstream call, and an unknown org `404 not_found`.
 *
 * The confirm token is a compare-and-swap: account-service evaluates it inside the same row lock
 * as the link endpoint (spec `018-salesforce-unlink-cas`), so it is the authoritative guard.
 *
 * A blank `reason` is rejected with `400` *before* any of the above.
 */
export const useClearSalesforceAccount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SalesforceAccountLinkResult,
      ClearSalesforceAccountError,
      ClearSalesforceAccountVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.SalesforceAccountLinkResult,
    ClearSalesforceAccountError,
    ClearSalesforceAccountVariables
  >({
    mutationFn: (variables: ClearSalesforceAccountVariables) =>
      fetchClearSalesforceAccount({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type ListOrganizationsBySalesforceAccountPathParams = {
  /**
   * The Salesforce account id to look up — 15- or 18-character alphanumeric (mirrors the
   * account-service format). Validated at this boundary so a malformed id never reaches
   * account-service.
   *
   * @pattern ^[A-Za-z0-9]{15}([A-Za-z0-9]{3})?$
   */
  salesforceAccountId: string
}

export type ListOrganizationsBySalesforceAccountError =
  Fetcher.ErrorWrapper<undefined>

export type ListOrganizationsBySalesforceAccountVariables = {
  pathParams: ListOrganizationsBySalesforceAccountPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Returns every organisation hivemq-account-service reports as linked to this Salesforce account
 * — the inverse of `GET /api/v3/orgs/{orgId}/salesforce-account`. account-service is the **sole
 * store** of `salesforceAccountId`, so this is a read-through on every call and nothing is
 * persisted, cached, or copied cloud-side.
 *
 * **An empty `orgs` array is a normal `200`, never a `404`.** The account id is a query term, not
 * a resource whose absence is meaningful, and an unknown account is indistinguishable from a known
 * account with nothing linked — both answer `200` with `[]`.
 *
 * **A failure is never reported as an empty result.** `503` means the account-service client is
 * disabled and `502` means the read failed; neither means "there are no linked organisations".
 * Reading "we could not ask" as "nothing is linked" is exactly what silently creates a duplicate
 * organisation, so these statuses must be surfaced to the operator rather than treated as an empty
 * list.
 *
 * The result is complete and uncapped — no pagination, no cursor, no truncation marker: the
 * endpoint exists to surface duplicates, and truncating hides exactly what it reports. Entries are
 * ordered by organisation id ascending, which makes repeat calls on the same upstream answer
 * deterministic. **The order carries no meaning** — it conveys neither primacy nor recency, and no
 * field marks any organisation as primary, first, or most recent.
 *
 * Matching is on the **15-character prefix**: an organisation linked with the 15-character form is
 * found by an 18-character query and vice versa. **Case is not folded**, so a differently-cased id
 * does not match. This equivalence is **lookup-only** — `PUT` and `DELETE
 * /api/v3/orgs/{orgId}/salesforce-account` compare the stored value as an exact string, so a value
 * taken from this response must be used in its **originally stored form** as the compare-and-swap
 * token there.
 */
export const fetchListOrganizationsBySalesforceAccount = (
  variables: ListOrganizationsBySalesforceAccountVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.SalesforceAccountOrgs,
    ListOrganizationsBySalesforceAccountError,
    undefined,
    {},
    {},
    ListOrganizationsBySalesforceAccountPathParams
  >({
    url: '/api/v3/salesforce-accounts/{salesforceAccountId}/orgs',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns every organisation hivemq-account-service reports as linked to this Salesforce account
 * — the inverse of `GET /api/v3/orgs/{orgId}/salesforce-account`. account-service is the **sole
 * store** of `salesforceAccountId`, so this is a read-through on every call and nothing is
 * persisted, cached, or copied cloud-side.
 *
 * **An empty `orgs` array is a normal `200`, never a `404`.** The account id is a query term, not
 * a resource whose absence is meaningful, and an unknown account is indistinguishable from a known
 * account with nothing linked — both answer `200` with `[]`.
 *
 * **A failure is never reported as an empty result.** `503` means the account-service client is
 * disabled and `502` means the read failed; neither means "there are no linked organisations".
 * Reading "we could not ask" as "nothing is linked" is exactly what silently creates a duplicate
 * organisation, so these statuses must be surfaced to the operator rather than treated as an empty
 * list.
 *
 * The result is complete and uncapped — no pagination, no cursor, no truncation marker: the
 * endpoint exists to surface duplicates, and truncating hides exactly what it reports. Entries are
 * ordered by organisation id ascending, which makes repeat calls on the same upstream answer
 * deterministic. **The order carries no meaning** — it conveys neither primacy nor recency, and no
 * field marks any organisation as primary, first, or most recent.
 *
 * Matching is on the **15-character prefix**: an organisation linked with the 15-character form is
 * found by an 18-character query and vice versa. **Case is not folded**, so a differently-cased id
 * does not match. This equivalence is **lookup-only** — `PUT` and `DELETE
 * /api/v3/orgs/{orgId}/salesforce-account` compare the stored value as an exact string, so a value
 * taken from this response must be used in its **originally stored form** as the compare-and-swap
 * token there.
 */
export const useListOrganizationsBySalesforceAccount = <
  TData = Schemas.SalesforceAccountOrgs,
>(
  variables: ListOrganizationsBySalesforceAccountVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SalesforceAccountOrgs,
      ListOrganizationsBySalesforceAccountError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.SalesforceAccountOrgs,
    ListOrganizationsBySalesforceAccountError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/salesforce-accounts/{salesforceAccountId}/orgs',
      operationId: 'listOrganizationsBySalesforceAccount',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListOrganizationsBySalesforceAccount(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  })
}

export type GetOrgUsersPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type GetOrgUsersError = Fetcher.ErrorWrapper<undefined>

export type GetOrgUsersResponse = Schemas.OrgUser[]

export type GetOrgUsersVariables = {
  pathParams: GetOrgUsersPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Retrieve all users in an organisation with their RBAC roles
 */
export const fetchGetOrgUsers = (
  variables: GetOrgUsersVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    GetOrgUsersResponse,
    GetOrgUsersError,
    undefined,
    {},
    {},
    GetOrgUsersPathParams
  >({ url: '/api/v3/orgs/{orgId}/users', method: 'get', ...variables, signal })

/**
 * Retrieve all users in an organisation with their RBAC roles
 */
export const useGetOrgUsers = <TData = GetOrgUsersResponse>(
  variables: GetOrgUsersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetOrgUsersResponse, GetOrgUsersError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<GetOrgUsersResponse, GetOrgUsersError, TData>({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/users',
      operationId: 'getOrgUsers',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetOrgUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type AddOrganizationMembersPathParams = {
  /**
   * Organization ID
   */
  orgId: string
}

export type AddOrganizationMembersError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * @example Duplicate email in request.
     */
    message?: string
  }
}>

export type AddOrganizationMembersVariables = {
  body: Schemas.AddOrganizationMembersRequest
  pathParams: AddOrganizationMembersPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Adds 1 to 10 people to an existing organization. Each member is given by `email`, by `userId`, or by
 * both, and is resolved server side with the same rules as `lookupUserIdentities`. A given `userId` is
 * re-validated against the identities of its email. Only what is missing is created: a new person gets
 * an Auth0 database user, a Stripe customer and a platform account; an existing identity without a
 * platform account gets a Stripe customer and a platform account. The member is then added to the
 * organization as a completed (not pending) member and given the default RBAC role `admin` or `viewer`.
 *
 * The call is synchronous: the response is sent once every member has an outcome. At most 3 members
 * are processed at the same time. Results are returned in request order, one per requested member.
 * The response is `200` whenever the request itself is valid, even if every member is blocked or
 * failed. Members fail independently; one member's failure never fails another member or the request.
 *
 * If the organization has SSO enabled, every member is `BLOCKED_SSO` with reason `ORG_SSO_ENABLED` and
 * nothing is written.
 *
 * Each `CREATED` member receives one invite email with a link to set their password (valid 7 days), and
 * each `ATTACHED_EXISTING` member receives one invite email with a console link that opens the
 * organization. No other outcome sends an email. The invite email is best-effort: whether SendGrid
 * accepted the send request is reported per member in `emailSent`, and a failed email never changes the
 * member's outcome or fails the request. New users may additionally receive the Auth0 welcome email
 * sent when their Auth0 user is created.
 *
 * A new member that fails before it is added to the organization has the resources created for it in
 * this request removed again (platform account, then Stripe customer, then Auth0 user). If any of these
 * removals fails, the outcome is `FAILED` with reason `CLEANUP_INCOMPLETE` and `leftovers` lists what
 * was not removed. Nothing is removed for an existing user, and nothing is removed once a member was
 * added to the organization.
 *
 * | outcome | reasons |
 * |---|---|
 * | `CREATED` | none: a new user was created and added |
 * | `ATTACHED_EXISTING` | none: an existing identity was added |
 * | `ALREADY_MEMBER` | `ACTIVE_MEMBER`, `PENDING_INVITATION` |
 * | `BLOCKED_SSO` | `ORG_SSO_ENABLED`, `SSO_DOMAIN_NO_IDENTITY`, `IDENTITY_NOT_SELECTABLE`, `NO_SELECTABLE_IDENTITY` |
 * | `BLOCKED_UNVERIFIED` | `IDENTITY_NOT_SELECTABLE`, `NO_SELECTABLE_IDENTITY` |
 * | `FAILED` | `USER_NOT_FOUND`, `USER_EMAIL_UNUSABLE`, `USER_ID_NOT_FOR_EMAIL`, `USER_ID_REQUIRED`, `LOOKUP_FAILED`, `AUTH0_CREATE_FAILED`, `STRIPE_CREATE_FAILED`, `ACCOUNT_CREATE_FAILED`, `MEMBERSHIP_FAILED`, `ROLE_ASSIGNMENT_FAILED`, `CLEANUP_INCOMPLETE` |
 *
 * | reason | meaning |
 * |---|---|
 * | `ACTIVE_MEMBER` | The identity is already a member of the organization. |
 * | `PENDING_INVITATION` | The identity has a pending invitation to the organization; it is not promoted. |
 * | `ORG_SSO_ENABLED` | The organization has SSO enabled. |
 * | `SSO_DOMAIN_NO_IDENTITY` | The email's domain is SSO-claimed and no enterprise identity of the claiming connection exists. |
 * | `IDENTITY_NOT_SELECTABLE` | The given `userId` cannot log in: `BLOCKED_SSO` when SSO prevents it, `BLOCKED_UNVERIFIED` when its email is not verified. |
 * | `NO_SELECTABLE_IDENTITY` | Identities exist for the email but none can log in: `BLOCKED_UNVERIFIED` when verifying an email would unblock one, else `BLOCKED_SSO`. |
 * | `USER_NOT_FOUND` | The given `userId` does not exist in Auth0. |
 * | `USER_EMAIL_UNUSABLE` | The Auth0 user of the given `userId` has no usable email. |
 * | `USER_ID_NOT_FOR_EMAIL` | The given `userId` is not an identity of the email. |
 * | `USER_ID_REQUIRED` | Several identities of the email are selectable; send the `userId` to use. |
 * | `LOOKUP_FAILED` | Resolving the member failed; nothing was written. |
 * | `AUTH0_CREATE_FAILED` | Creating the Auth0 user failed. |
 * | `STRIPE_CREATE_FAILED` | Creating the Stripe customer failed. |
 * | `ACCOUNT_CREATE_FAILED` | Creating the platform account failed. |
 * | `MEMBERSHIP_FAILED` | Adding the member to the organization failed. |
 * | `ROLE_ASSIGNMENT_FAILED` | The member was added but its role could not be assigned; fix it with `replaceUserRoles`. |
 * | `CLEANUP_INCOMPLETE` | The member failed and some resources created for it could not be removed; see `leftovers`. |
 */
export const fetchAddOrganizationMembers = (
  variables: AddOrganizationMembersVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.AddOrganizationMembersResponse,
    AddOrganizationMembersError,
    Schemas.AddOrganizationMembersRequest,
    {},
    {},
    AddOrganizationMembersPathParams
  >({
    url: '/api/v3/orgs/{orgId}/members',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Adds 1 to 10 people to an existing organization. Each member is given by `email`, by `userId`, or by
 * both, and is resolved server side with the same rules as `lookupUserIdentities`. A given `userId` is
 * re-validated against the identities of its email. Only what is missing is created: a new person gets
 * an Auth0 database user, a Stripe customer and a platform account; an existing identity without a
 * platform account gets a Stripe customer and a platform account. The member is then added to the
 * organization as a completed (not pending) member and given the default RBAC role `admin` or `viewer`.
 *
 * The call is synchronous: the response is sent once every member has an outcome. At most 3 members
 * are processed at the same time. Results are returned in request order, one per requested member.
 * The response is `200` whenever the request itself is valid, even if every member is blocked or
 * failed. Members fail independently; one member's failure never fails another member or the request.
 *
 * If the organization has SSO enabled, every member is `BLOCKED_SSO` with reason `ORG_SSO_ENABLED` and
 * nothing is written.
 *
 * Each `CREATED` member receives one invite email with a link to set their password (valid 7 days), and
 * each `ATTACHED_EXISTING` member receives one invite email with a console link that opens the
 * organization. No other outcome sends an email. The invite email is best-effort: whether SendGrid
 * accepted the send request is reported per member in `emailSent`, and a failed email never changes the
 * member's outcome or fails the request. New users may additionally receive the Auth0 welcome email
 * sent when their Auth0 user is created.
 *
 * A new member that fails before it is added to the organization has the resources created for it in
 * this request removed again (platform account, then Stripe customer, then Auth0 user). If any of these
 * removals fails, the outcome is `FAILED` with reason `CLEANUP_INCOMPLETE` and `leftovers` lists what
 * was not removed. Nothing is removed for an existing user, and nothing is removed once a member was
 * added to the organization.
 *
 * | outcome | reasons |
 * |---|---|
 * | `CREATED` | none: a new user was created and added |
 * | `ATTACHED_EXISTING` | none: an existing identity was added |
 * | `ALREADY_MEMBER` | `ACTIVE_MEMBER`, `PENDING_INVITATION` |
 * | `BLOCKED_SSO` | `ORG_SSO_ENABLED`, `SSO_DOMAIN_NO_IDENTITY`, `IDENTITY_NOT_SELECTABLE`, `NO_SELECTABLE_IDENTITY` |
 * | `BLOCKED_UNVERIFIED` | `IDENTITY_NOT_SELECTABLE`, `NO_SELECTABLE_IDENTITY` |
 * | `FAILED` | `USER_NOT_FOUND`, `USER_EMAIL_UNUSABLE`, `USER_ID_NOT_FOR_EMAIL`, `USER_ID_REQUIRED`, `LOOKUP_FAILED`, `AUTH0_CREATE_FAILED`, `STRIPE_CREATE_FAILED`, `ACCOUNT_CREATE_FAILED`, `MEMBERSHIP_FAILED`, `ROLE_ASSIGNMENT_FAILED`, `CLEANUP_INCOMPLETE` |
 *
 * | reason | meaning |
 * |---|---|
 * | `ACTIVE_MEMBER` | The identity is already a member of the organization. |
 * | `PENDING_INVITATION` | The identity has a pending invitation to the organization; it is not promoted. |
 * | `ORG_SSO_ENABLED` | The organization has SSO enabled. |
 * | `SSO_DOMAIN_NO_IDENTITY` | The email's domain is SSO-claimed and no enterprise identity of the claiming connection exists. |
 * | `IDENTITY_NOT_SELECTABLE` | The given `userId` cannot log in: `BLOCKED_SSO` when SSO prevents it, `BLOCKED_UNVERIFIED` when its email is not verified. |
 * | `NO_SELECTABLE_IDENTITY` | Identities exist for the email but none can log in: `BLOCKED_UNVERIFIED` when verifying an email would unblock one, else `BLOCKED_SSO`. |
 * | `USER_NOT_FOUND` | The given `userId` does not exist in Auth0. |
 * | `USER_EMAIL_UNUSABLE` | The Auth0 user of the given `userId` has no usable email. |
 * | `USER_ID_NOT_FOR_EMAIL` | The given `userId` is not an identity of the email. |
 * | `USER_ID_REQUIRED` | Several identities of the email are selectable; send the `userId` to use. |
 * | `LOOKUP_FAILED` | Resolving the member failed; nothing was written. |
 * | `AUTH0_CREATE_FAILED` | Creating the Auth0 user failed. |
 * | `STRIPE_CREATE_FAILED` | Creating the Stripe customer failed. |
 * | `ACCOUNT_CREATE_FAILED` | Creating the platform account failed. |
 * | `MEMBERSHIP_FAILED` | Adding the member to the organization failed. |
 * | `ROLE_ASSIGNMENT_FAILED` | The member was added but its role could not be assigned; fix it with `replaceUserRoles`. |
 * | `CLEANUP_INCOMPLETE` | The member failed and some resources created for it could not be removed; see `leftovers`. |
 */
export const useAddOrganizationMembers = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AddOrganizationMembersResponse,
      AddOrganizationMembersError,
      AddOrganizationMembersVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.AddOrganizationMembersResponse,
    AddOrganizationMembersError,
    AddOrganizationMembersVariables
  >({
    mutationFn: (variables: AddOrganizationMembersVariables) =>
      fetchAddOrganizationMembers({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetOrgRolesPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type GetOrgRolesError = Fetcher.ErrorWrapper<undefined>

export type GetOrgRolesVariables = {
  pathParams: GetOrgRolesPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Retrieve the RBAC roles defined for an organisation. Used to discover the role IDs that can be assigned to a user via replaceUserRoles.
 */
export const fetchGetOrgRoles = (
  variables: GetOrgRolesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.RoleList,
    GetOrgRolesError,
    undefined,
    {},
    {},
    GetOrgRolesPathParams
  >({ url: '/api/v3/orgs/{orgId}/roles', method: 'get', ...variables, signal })

/**
 * Retrieve the RBAC roles defined for an organisation. Used to discover the role IDs that can be assigned to a user via replaceUserRoles.
 */
export const useGetOrgRoles = <TData = Schemas.RoleList>(
  variables: GetOrgRolesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.RoleList, GetOrgRolesError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<Schemas.RoleList, GetOrgRolesError, TData>({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/roles',
      operationId: 'getOrgRoles',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetOrgRoles({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type ReplaceUserRolesPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
  /**
   * User ID (Auth0 identifier) of the user whose roles are being replaced
   */
  userId: string
}

export type ReplaceUserRolesError = Fetcher.ErrorWrapper<undefined>

export type ReplaceUserRolesVariables = {
  body: Schemas.ReplaceUserRolesRequest
  pathParams: ReplaceUserRolesPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Replaces the full set of RBAC roles for a user within an organisation with exactly the roles supplied. This is a destructive replace, not an additive assignment: any role not included in the request is removed. A reason must be provided and is recorded in the audit log on a best-effort basis: if the audit push fails the change still succeeds, and the failure is logged at ERROR and counted in backoffice_audit_push_failures_total.
 * Callers holding OPERATOR or GTM but not ADMIN can only change the roles of a user who is listed in the organisation's members, whether or not they currently hold any role (so a member whose role assignment failed can be repaired). A user not listed is rejected with 404 and nothing is written; add them as a member first. ADMIN callers are not subject to this check.
 */
export const fetchReplaceUserRoles = (
  variables: ReplaceUserRolesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    ReplaceUserRolesError,
    Schemas.ReplaceUserRolesRequest,
    {},
    {},
    ReplaceUserRolesPathParams
  >({
    url: '/api/v3/orgs/{orgId}/users/{userId}/roles',
    method: 'put',
    ...variables,
    signal,
  })

/**
 * Replaces the full set of RBAC roles for a user within an organisation with exactly the roles supplied. This is a destructive replace, not an additive assignment: any role not included in the request is removed. A reason must be provided and is recorded in the audit log on a best-effort basis: if the audit push fails the change still succeeds, and the failure is logged at ERROR and counted in backoffice_audit_push_failures_total.
 * Callers holding OPERATOR or GTM but not ADMIN can only change the roles of a user who is listed in the organisation's members, whether or not they currently hold any role (so a member whose role assignment failed can be repaired). A user not listed is rejected with 404 and nothing is written; add them as a member first. ADMIN callers are not subject to this check.
 */
export const useReplaceUserRoles = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ReplaceUserRolesError,
      ReplaceUserRolesVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    undefined,
    ReplaceUserRolesError,
    ReplaceUserRolesVariables
  >({
    mutationFn: (variables: ReplaceUserRolesVariables) =>
      fetchReplaceUserRoles({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type AssignUserRolePathParams = {
  /**
   * Organisation ID
   */
  orgId: string
  /**
   * User ID (Auth0 identifier) of the user being assigned the role
   */
  userId: string
}

export type AssignUserRoleError = Fetcher.ErrorWrapper<undefined>

export type AssignUserRoleVariables = {
  body: Schemas.AssignUserRoleRequest
  pathParams: AssignUserRolePathParams
} & V3ApiContext['fetcherOptions']

/**
 * Additively assigns a single role (by name) to a user within an organisation, also creating the user's organisation membership if it does not yet exist. Unlike the PUT (replace) operation this does not remove the user's existing roles. A reason must be provided and is recorded in the audit log.
 */
export const fetchAssignUserRole = (
  variables: AssignUserRoleVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.UserRoleAssignment,
    AssignUserRoleError,
    Schemas.AssignUserRoleRequest,
    {},
    {},
    AssignUserRolePathParams
  >({
    url: '/api/v3/orgs/{orgId}/users/{userId}/roles',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Additively assigns a single role (by name) to a user within an organisation, also creating the user's organisation membership if it does not yet exist. Unlike the PUT (replace) operation this does not remove the user's existing roles. A reason must be provided and is recorded in the audit log.
 */
export const useAssignUserRole = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserRoleAssignment,
      AssignUserRoleError,
      AssignUserRoleVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.UserRoleAssignment,
    AssignUserRoleError,
    AssignUserRoleVariables
  >({
    mutationFn: (variables: AssignUserRoleVariables) =>
      fetchAssignUserRole({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type RemoveUserFromOrgPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
  /**
   * User ID (Auth0 identifier) of the user being removed from the organisation
   */
  userId: string
}

export type RemoveUserFromOrgQueryParams = {
  /**
   * Reason for removing the user, recorded in the audit log.
   *
   * @minLength 1
   */
  reason: string
}

export type RemoveUserFromOrgError = Fetcher.ErrorWrapper<undefined>

export type RemoveUserFromOrgVariables = {
  pathParams: RemoveUserFromOrgPathParams
  queryParams: RemoveUserFromOrgQueryParams
} & V3ApiContext['fetcherOptions']

/**
 * Removes a user from an organisation: deletes the user's organisation membership and cleans up their RBAC roles. Membership removal is authoritative; role cleanup is best-effort. A reason must be provided and is recorded in the audit log.
 */
export const fetchRemoveUserFromOrg = (
  variables: RemoveUserFromOrgVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    RemoveUserFromOrgError,
    undefined,
    {},
    RemoveUserFromOrgQueryParams,
    RemoveUserFromOrgPathParams
  >({
    url: '/api/v3/orgs/{orgId}/users/{userId}/roles',
    method: 'delete',
    ...variables,
    signal,
  })

/**
 * Removes a user from an organisation: deletes the user's organisation membership and cleans up their RBAC roles. Membership removal is authoritative; role cleanup is best-effort. A reason must be provided and is recorded in the audit log.
 */
export const useRemoveUserFromOrg = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RemoveUserFromOrgError,
      RemoveUserFromOrgVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    undefined,
    RemoveUserFromOrgError,
    RemoveUserFromOrgVariables
  >({
    mutationFn: (variables: RemoveUserFromOrgVariables) =>
      fetchRemoveUserFromOrg({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type ListSupportUsersPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type ListSupportUsersError = Fetcher.ErrorWrapper<undefined>

export type ListSupportUsersVariables = {
  pathParams: ListSupportUsersPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Retrieve all HiveMQ support users currently assigned to this organisation
 */
export const fetchListSupportUsers = (
  variables: ListSupportUsersVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.SupportUserList,
    ListSupportUsersError,
    undefined,
    {},
    {},
    ListSupportUsersPathParams
  >({
    url: '/api/v3/orgs/{orgId}/support-users',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Retrieve all HiveMQ support users currently assigned to this organisation
 */
export const useListSupportUsers = <TData = Schemas.SupportUserList>(
  variables: ListSupportUsersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SupportUserList,
      ListSupportUsersError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.SupportUserList,
    ListSupportUsersError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/support-users',
      operationId: 'listSupportUsers',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListSupportUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type AddSupportUserPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type AddSupportUserError = Fetcher.ErrorWrapper<undefined>

export type AddSupportUserVariables = {
  body: Schemas.AddSupportUserRequest
  pathParams: AddSupportUserPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Assign a HiveMQ support user to a customer organisation with the support_admin role
 */
export const fetchAddSupportUser = (
  variables: AddSupportUserVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.SupportUser,
    AddSupportUserError,
    Schemas.AddSupportUserRequest,
    {},
    {},
    AddSupportUserPathParams
  >({
    url: '/api/v3/orgs/{orgId}/support-users',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Assign a HiveMQ support user to a customer organisation with the support_admin role
 */
export const useAddSupportUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SupportUser,
      AddSupportUserError,
      AddSupportUserVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.SupportUser,
    AddSupportUserError,
    AddSupportUserVariables
  >({
    mutationFn: (variables: AddSupportUserVariables) =>
      fetchAddSupportUser({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type RemoveSupportUserPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
  /**
   * Support user ID to remove
   */
  userId: string
}

export type RemoveSupportUserError = Fetcher.ErrorWrapper<undefined>

export type RemoveSupportUserVariables = {
  pathParams: RemoveSupportUserPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Remove a HiveMQ support user from a customer organisation
 */
export const fetchRemoveSupportUser = (
  variables: RemoveSupportUserVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    RemoveSupportUserError,
    undefined,
    {},
    {},
    RemoveSupportUserPathParams
  >({
    url: '/api/v3/orgs/{orgId}/support-users/{userId}',
    method: 'delete',
    ...variables,
    signal,
  })

/**
 * Remove a HiveMQ support user from a customer organisation
 */
export const useRemoveSupportUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RemoveSupportUserError,
      RemoveSupportUserVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    undefined,
    RemoveSupportUserError,
    RemoveSupportUserVariables
  >({
    mutationFn: (variables: RemoveSupportUserVariables) =>
      fetchRemoveSupportUser({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetOrganizationClusterTagsPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type GetOrganizationClusterTagsError = Fetcher.ErrorWrapper<undefined>

export type GetOrganizationClusterTagsResponse = string[]

export type GetOrganizationClusterTagsVariables = {
  pathParams: GetOrganizationClusterTagsPathParams
} & V3ApiContext['fetcherOptions']

export const fetchGetOrganizationClusterTags = (
  variables: GetOrganizationClusterTagsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    GetOrganizationClusterTagsResponse,
    GetOrganizationClusterTagsError,
    undefined,
    {},
    {},
    GetOrganizationClusterTagsPathParams
  >({ url: '/api/v3/orgs/{orgId}/tags', method: 'get', ...variables, signal })

export const useGetOrganizationClusterTags = <
  TData = GetOrganizationClusterTagsResponse,
>(
  variables: GetOrganizationClusterTagsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetOrganizationClusterTagsResponse,
      GetOrganizationClusterTagsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    GetOrganizationClusterTagsResponse,
    GetOrganizationClusterTagsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/tags',
      operationId: 'getOrganizationClusterTags',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetOrganizationClusterTags(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  })
}

export type GetOrganisationIdpConnectionsPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type GetOrganisationIdpConnectionsError = Fetcher.ErrorWrapper<undefined>

export type GetOrganisationIdpConnectionsVariables = {
  pathParams: GetOrganisationIdpConnectionsPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Retrieve all identity provider connections for the organization
 */
export const fetchGetOrganisationIdpConnections = (
  variables: GetOrganisationIdpConnectionsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.IdpConnectionsResponse,
    GetOrganisationIdpConnectionsError,
    undefined,
    {},
    {},
    GetOrganisationIdpConnectionsPathParams
  >({
    url: '/api/v3/orgs/{orgId}/idpConnections',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Retrieve all identity provider connections for the organization
 */
export const useGetOrganisationIdpConnections = <
  TData = Schemas.IdpConnectionsResponse,
>(
  variables: GetOrganisationIdpConnectionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.IdpConnectionsResponse,
      GetOrganisationIdpConnectionsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.IdpConnectionsResponse,
    GetOrganisationIdpConnectionsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/idpConnections',
      operationId: 'getOrganisationIdpConnections',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetOrganisationIdpConnections(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  })
}

export type UpdateOrganisationIdpConnectionPathParams = {
  /**
   * HiveMQ Organization ID
   */
  orgId: string
  /**
   * Auth0 SSO connection ID to update
   */
  connectionId: string
}

export type UpdateOrganisationIdpConnectionError =
  Fetcher.ErrorWrapper<undefined>

export type UpdateOrganisationIdpConnectionRequestBody = {
  /**
   * Indicates whether the IDP connection should be enabled or disabled.
   */
  enabled?: boolean
}

export type UpdateOrganisationIdpConnectionVariables = {
  body?: UpdateOrganisationIdpConnectionRequestBody
  pathParams: UpdateOrganisationIdpConnectionPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Updates (Enable/Disable) an existing identity provider connection for the organization. The authenticated user must be an owner or admin of the organization.
 */
export const fetchUpdateOrganisationIdpConnection = (
  variables: UpdateOrganisationIdpConnectionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.IdpConnection,
    UpdateOrganisationIdpConnectionError,
    UpdateOrganisationIdpConnectionRequestBody,
    {},
    {},
    UpdateOrganisationIdpConnectionPathParams
  >({
    url: '/api/v3/orgs/{orgId}/idpConnections/{connectionId}',
    method: 'patch',
    ...variables,
    signal,
  })

/**
 * Updates (Enable/Disable) an existing identity provider connection for the organization. The authenticated user must be an owner or admin of the organization.
 */
export const useUpdateOrganisationIdpConnection = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.IdpConnection,
      UpdateOrganisationIdpConnectionError,
      UpdateOrganisationIdpConnectionVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.IdpConnection,
    UpdateOrganisationIdpConnectionError,
    UpdateOrganisationIdpConnectionVariables
  >({
    mutationFn: (variables: UpdateOrganisationIdpConnectionVariables) =>
      fetchUpdateOrganisationIdpConnection({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetClusterPathParams = {
  orgId: string
  clusterId: string
}

export type GetClusterError = Fetcher.ErrorWrapper<undefined>

export type GetClusterVariables = {
  pathParams: GetClusterPathParams
} & V3ApiContext['fetcherOptions']

export const fetchGetCluster = (
  variables: GetClusterVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClusterHead,
    GetClusterError,
    undefined,
    {},
    {},
    GetClusterPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}',
    method: 'get',
    ...variables,
    signal,
  })

export const useGetCluster = <TData = Schemas.ClusterHead>(
  variables: GetClusterVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ClusterHead, GetClusterError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<Schemas.ClusterHead, GetClusterError, TData>({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}',
      operationId: 'getCluster',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetCluster({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type DeleteClusterPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
  /**
   * Cluster id to delete
   */
  clusterId: string
}

export type DeleteClusterError = Fetcher.ErrorWrapper<undefined>

export type DeleteClusterVariables = {
  pathParams: DeleteClusterPathParams
} & V3ApiContext['fetcherOptions']

/**
 * delete a Cluster
 */
export const fetchDeleteCluster = (
  variables: DeleteClusterVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    DeleteClusterError,
    undefined,
    {},
    {},
    DeleteClusterPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}',
    method: 'delete',
    ...variables,
    signal,
  })

/**
 * delete a Cluster
 */
export const useDeleteCluster = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteClusterError,
      DeleteClusterVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    undefined,
    DeleteClusterError,
    DeleteClusterVariables
  >({
    mutationFn: (variables: DeleteClusterVariables) =>
      fetchDeleteCluster({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type PutClusterPathParams = {
  orgId: string
  clusterId: string
}

export type PutClusterError = Fetcher.ErrorWrapper<undefined>

export type PutClusterVariables = {
  body: Schemas.ClusterUpdate
  pathParams: PutClusterPathParams
} & V3ApiContext['fetcherOptions']

export const fetchPutCluster = (
  variables: PutClusterVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.RevisionResponse,
    PutClusterError,
    Schemas.ClusterUpdate,
    {},
    {},
    PutClusterPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}',
    method: 'put',
    ...variables,
    signal,
  })

export const usePutCluster = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RevisionResponse,
      PutClusterError,
      PutClusterVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.RevisionResponse,
    PutClusterError,
    PutClusterVariables
  >({
    mutationFn: (variables: PutClusterVariables) =>
      fetchPutCluster({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetBulkClusterUpdatesDetailsQueryParams = {
  /**
   * Workflow status (e.g., RUNNING, COMPLETED, FAILED, etc.)
   */
  status?: string
  /**
   * Filter by start date (epoch milliseconds)
   *
   * @format int64
   */
  startDate?: number
  /**
   * Filter by end date (epoch milliseconds)
   *
   * @format int64
   */
  endDate?: number
  /**
   * Temporal namespace to filter by
   */
  namespace?: string
  /**
   * @default 50
   */
  pageSize?: number
  /**
   * Token to fetch the next page of results
   */
  nextPageToken?: string
  /**
   * Filter by workflow type name (e.g, BulkUpdateWorkflow)
   *
   * @default BulkUpdateWorkflow
   */
  type?: string
  /**
   * Filter by workflow ID
   */
  workflowId?: string
}

export type GetBulkClusterUpdatesDetailsError = Fetcher.ErrorWrapper<undefined>

export type GetBulkClusterUpdatesDetailsResponse = {
  workflows?: {
    workflowId?: string
    runId?: string
    type?: string
    status?: string
    /**
     * Start time in epoch milliseconds
     *
     * @format int64
     */
    startTime?: number
    /**
     * Execution time in epoch milliseconds
     *
     * @format int64
     */
    executionTime?: number
    namespace?: string
  }[]
  /**
   * Token for fetching the next page of results
   */
  nextPageToken?: string
}

export type GetBulkClusterUpdatesDetailsVariables = {
  queryParams?: GetBulkClusterUpdatesDetailsQueryParams
} & V3ApiContext['fetcherOptions']

/**
 * Retrieve a list of all update / bulk cluster details
 */
export const fetchGetBulkClusterUpdatesDetails = (
  variables: GetBulkClusterUpdatesDetailsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    GetBulkClusterUpdatesDetailsResponse,
    GetBulkClusterUpdatesDetailsError,
    undefined,
    {},
    GetBulkClusterUpdatesDetailsQueryParams,
    {}
  >({
    url: '/api/v3/clusters/bulk-update/details',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Retrieve a list of all update / bulk cluster details
 */
export const useGetBulkClusterUpdatesDetails = <
  TData = GetBulkClusterUpdatesDetailsResponse,
>(
  variables: GetBulkClusterUpdatesDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetBulkClusterUpdatesDetailsResponse,
      GetBulkClusterUpdatesDetailsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    GetBulkClusterUpdatesDetailsResponse,
    GetBulkClusterUpdatesDetailsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/clusters/bulk-update/details',
      operationId: 'getBulkClusterUpdatesDetails',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetBulkClusterUpdatesDetails(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  })
}

export type GetBulkClusterUpdatesQueryParams = {
  /**
   * The page number for pagination.
   *
   * @format int32
   * @default 1
   */
  page?: number
  /**
   * @example asc
   * @default desc
   */
  order?: 'asc' | 'desc'
}

export type GetBulkClusterUpdatesError = Fetcher.ErrorWrapper<undefined>

export type GetBulkClusterUpdatesVariables = {
  queryParams?: GetBulkClusterUpdatesQueryParams
} & V3ApiContext['fetcherOptions']

/**
 * Retrieve a list of all bulk cluster update requests with their current status
 */
export const fetchGetBulkClusterUpdates = (
  variables: GetBulkClusterUpdatesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.BulkUpdatesResponse,
    GetBulkClusterUpdatesError,
    undefined,
    {},
    GetBulkClusterUpdatesQueryParams,
    {}
  >({
    url: '/api/v3/clusters/bulk-update',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Retrieve a list of all bulk cluster update requests with their current status
 */
export const useGetBulkClusterUpdates = <TData = Schemas.BulkUpdatesResponse>(
  variables: GetBulkClusterUpdatesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BulkUpdatesResponse,
      GetBulkClusterUpdatesError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.BulkUpdatesResponse,
    GetBulkClusterUpdatesError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/clusters/bulk-update',
      operationId: 'getBulkClusterUpdates',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetBulkClusterUpdates({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type SubmitBulkClusterUpdateError = Fetcher.ErrorWrapper<undefined>

export type SubmitBulkClusterUpdateResponse = {
  /**
   * Unique identifier for the bulk update operation
   */
  bulkUpdateId: string
}

export type SubmitBulkClusterUpdateVariables = {
  body: Schemas.BulkClusterUpdate
} & V3ApiContext['fetcherOptions']

/**
 * Submit multiple clusters for asynchronous update to a specified template. The clusters will be processed later and individual revisions will be created that require approval through the standard workflow.
 */
export const fetchSubmitBulkClusterUpdate = (
  variables: SubmitBulkClusterUpdateVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    SubmitBulkClusterUpdateResponse,
    SubmitBulkClusterUpdateError,
    Schemas.BulkClusterUpdate,
    {},
    {},
    {}
  >({
    url: '/api/v3/clusters/bulk-update',
    method: 'put',
    ...variables,
    signal,
  })

/**
 * Submit multiple clusters for asynchronous update to a specified template. The clusters will be processed later and individual revisions will be created that require approval through the standard workflow.
 */
export const useSubmitBulkClusterUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      SubmitBulkClusterUpdateResponse,
      SubmitBulkClusterUpdateError,
      SubmitBulkClusterUpdateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    SubmitBulkClusterUpdateResponse,
    SubmitBulkClusterUpdateError,
    SubmitBulkClusterUpdateVariables
  >({
    mutationFn: (variables: SubmitBulkClusterUpdateVariables) =>
      fetchSubmitBulkClusterUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetBulkClusterUpdateDetailsPathParams = {
  /**
   * Unique identifier of the bulk update task (Temporal Workflow ID).
   *
   * @format uuid
   * @example bulk-update-123e4567-e89b-12d3-a456-426614174000
   */
  bulkUpdateId: string
}

export type GetBulkClusterUpdateDetailsError = Fetcher.ErrorWrapper<undefined>

export type GetBulkClusterUpdateDetailsVariables = {
  pathParams: GetBulkClusterUpdateDetailsPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Retrieve comprehensive details about a single bulk cluster update request, including the status of each individual cluster affected.
 */
export const fetchGetBulkClusterUpdateDetails = (
  variables: GetBulkClusterUpdateDetailsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.BulkUpdateTaskDetails,
    GetBulkClusterUpdateDetailsError,
    undefined,
    {},
    {},
    GetBulkClusterUpdateDetailsPathParams
  >({
    url: '/api/v3/clusters/bulk-update/{bulkUpdateId}',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Retrieve comprehensive details about a single bulk cluster update request, including the status of each individual cluster affected.
 */
export const useGetBulkClusterUpdateDetails = <
  TData = Schemas.BulkUpdateTaskDetails,
>(
  variables: GetBulkClusterUpdateDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BulkUpdateTaskDetails,
      GetBulkClusterUpdateDetailsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.BulkUpdateTaskDetails,
    GetBulkClusterUpdateDetailsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/clusters/bulk-update/{bulkUpdateId}',
      operationId: 'getBulkClusterUpdateDetails',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetBulkClusterUpdateDetails(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  })
}

export type ApproveBulkUpdatePathParams = {
  bulkUpdateId: string
}

export type ApproveBulkUpdateError = Fetcher.ErrorWrapper<undefined>

export type ApproveBulkUpdateVariables = {
  body: Schemas.ApprovalRequest
  pathParams: ApproveBulkUpdatePathParams
} & V3ApiContext['fetcherOptions']

export const fetchApproveBulkUpdate = (
  variables: ApproveBulkUpdateVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    ApproveBulkUpdateError,
    Schemas.ApprovalRequest,
    {},
    {},
    ApproveBulkUpdatePathParams
  >({
    url: '/api/v3/clusters/bulk-update/{bulkUpdateId}/approve',
    method: 'put',
    ...variables,
    signal,
  })

export const useApproveBulkUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      ApproveBulkUpdateError,
      ApproveBulkUpdateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    ApproveBulkUpdateError,
    ApproveBulkUpdateVariables
  >({
    mutationFn: (variables: ApproveBulkUpdateVariables) =>
      fetchApproveBulkUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type RejectBulkUpdatePathParams = {
  bulkUpdateId: string
}

export type RejectBulkUpdateError = Fetcher.ErrorWrapper<undefined>

export type RejectBulkUpdateVariables = {
  body: Schemas.ApprovalRequest
  pathParams: RejectBulkUpdatePathParams
} & V3ApiContext['fetcherOptions']

export const fetchRejectBulkUpdate = (
  variables: RejectBulkUpdateVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    RejectBulkUpdateError,
    Schemas.ApprovalRequest,
    {},
    {},
    RejectBulkUpdatePathParams
  >({
    url: '/api/v3/clusters/bulk-update/{bulkUpdateId}/reject',
    method: 'put',
    ...variables,
    signal,
  })

export const useRejectBulkUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      RejectBulkUpdateError,
      RejectBulkUpdateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    RejectBulkUpdateError,
    RejectBulkUpdateVariables
  >({
    mutationFn: (variables: RejectBulkUpdateVariables) =>
      fetchRejectBulkUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type ApplyBulkUpdatePathParams = {
  bulkUpdateId: string
}

export type ApplyBulkUpdateError = Fetcher.ErrorWrapper<undefined>

export type ApplyBulkUpdateVariables = {
  body: Schemas.ApprovalRequest
  pathParams: ApplyBulkUpdatePathParams
} & V3ApiContext['fetcherOptions']

export const fetchApplyBulkUpdate = (
  variables: ApplyBulkUpdateVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    ApplyBulkUpdateError,
    Schemas.ApprovalRequest,
    {},
    {},
    ApplyBulkUpdatePathParams
  >({
    url: '/api/v3/clusters/bulk-update/{bulkUpdateId}/apply',
    method: 'put',
    ...variables,
    signal,
  })

export const useApplyBulkUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      ApplyBulkUpdateError,
      ApplyBulkUpdateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    ApplyBulkUpdateError,
    ApplyBulkUpdateVariables
  >({
    mutationFn: (variables: ApplyBulkUpdateVariables) =>
      fetchApplyBulkUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetApiariesError = Fetcher.ErrorWrapper<undefined>

export type GetApiariesResponse = string[]

export type GetApiariesVariables = V3ApiContext['fetcherOptions']

/**
 * Retrieve a list of all available apiary/deployment label IDs
 */
export const fetchGetApiaries = (
  variables: GetApiariesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<GetApiariesResponse, GetApiariesError, undefined, {}, {}, {}>({
    url: '/api/v3/apiaries',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Retrieve a list of all available apiary/deployment label IDs
 */
export const useGetApiaries = <TData = GetApiariesResponse>(
  variables: GetApiariesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetApiariesResponse, GetApiariesError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<GetApiariesResponse, GetApiariesError, TData>({
    queryKey: queryKeyFn({
      path: '/api/v3/apiaries',
      operationId: 'getApiaries',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetApiaries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type GetSupportedExtensionsError = Fetcher.ErrorWrapper<undefined>

export type GetSupportedExtensionsVariables = V3ApiContext['fetcherOptions']

/**
 * List of available cluster extensions
 */
export const fetchGetSupportedExtensions = (
  variables: GetSupportedExtensionsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.SupportedExtensionsList,
    GetSupportedExtensionsError,
    undefined,
    {},
    {},
    {}
  >({
    url: '/api/v3/clusters/extensions',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * List of available cluster extensions
 */
export const useGetSupportedExtensions = <
  TData = Schemas.SupportedExtensionsList,
>(
  variables: GetSupportedExtensionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SupportedExtensionsList,
      GetSupportedExtensionsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.SupportedExtensionsList,
    GetSupportedExtensionsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/clusters/extensions',
      operationId: 'getSupportedExtensions',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetSupportedExtensions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type ResyncHivePathParams = {
  orgId: string
  clusterId: string
}

export type ResyncHiveError = Fetcher.ErrorWrapper<undefined>

export type ResyncHiveVariables = {
  pathParams: ResyncHivePathParams
} & V3ApiContext['fetcherOptions']

export const fetchResyncHive = (
  variables: ResyncHiveVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    ResyncHiveError,
    undefined,
    {},
    {},
    ResyncHivePathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/resync',
    method: 'put',
    ...variables,
    signal,
  })

export const useResyncHive = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ResyncHiveError,
      ResyncHiveVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    undefined,
    ResyncHiveError,
    ResyncHiveVariables
  >({
    mutationFn: (variables: ResyncHiveVariables) =>
      fetchResyncHive({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type UpdateHiveCommentPathParams = {
  orgId: string
  clusterId: string
}

export type UpdateHiveCommentError = Fetcher.ErrorWrapper<undefined>

export type UpdateHiveCommentVariables = {
  body: Schemas.HiveCommentUpdate
  pathParams: UpdateHiveCommentPathParams
} & V3ApiContext['fetcherOptions']

export const fetchUpdateHiveComment = (
  variables: UpdateHiveCommentVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    UpdateHiveCommentError,
    Schemas.HiveCommentUpdate,
    {},
    {},
    UpdateHiveCommentPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/comment',
    method: 'put',
    ...variables,
    signal,
  })

export const useUpdateHiveComment = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateHiveCommentError,
      UpdateHiveCommentVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    undefined,
    UpdateHiveCommentError,
    UpdateHiveCommentVariables
  >({
    mutationFn: (variables: UpdateHiveCommentVariables) =>
      fetchUpdateHiveComment({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetClusterRevisionByIdPathParams = {
  orgId: string
  clusterId: string
  revisionId: string
}

export type GetClusterRevisionByIdError = Fetcher.ErrorWrapper<undefined>

export type GetClusterRevisionByIdVariables = {
  pathParams: GetClusterRevisionByIdPathParams
} & V3ApiContext['fetcherOptions']

export const fetchGetClusterRevisionById = (
  variables: GetClusterRevisionByIdVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClusterRevision,
    GetClusterRevisionByIdError,
    undefined,
    {},
    {},
    GetClusterRevisionByIdPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}',
    method: 'get',
    ...variables,
    signal,
  })

export const useGetClusterRevisionById = <TData = Schemas.ClusterRevision>(
  variables: GetClusterRevisionByIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ClusterRevision,
      GetClusterRevisionByIdError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.ClusterRevision,
    GetClusterRevisionByIdError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}',
      operationId: 'getClusterRevisionById',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetClusterRevisionById({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type GetClusterAppliedRevisionPathParams = {
  orgId: string
  clusterId: string
}

export type GetClusterAppliedRevisionError = Fetcher.ErrorWrapper<undefined>

export type GetClusterAppliedRevisionVariables = {
  pathParams: GetClusterAppliedRevisionPathParams
} & V3ApiContext['fetcherOptions']

export const fetchGetClusterAppliedRevision = (
  variables: GetClusterAppliedRevisionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClusterRevision,
    GetClusterAppliedRevisionError,
    undefined,
    {},
    {},
    GetClusterAppliedRevisionPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/applied',
    method: 'get',
    ...variables,
    signal,
  })

export const useGetClusterAppliedRevision = <TData = Schemas.ClusterRevision>(
  variables: GetClusterAppliedRevisionVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ClusterRevision,
      GetClusterAppliedRevisionError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.ClusterRevision,
    GetClusterAppliedRevisionError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}/applied',
      operationId: 'getClusterAppliedRevision',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetClusterAppliedRevision(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  })
}

export type GetClusterRevisionsPathParams = {
  orgId: string
  clusterId: string
}

export type GetClusterRevisionsError = Fetcher.ErrorWrapper<undefined>

export type GetClusterRevisionsResponse = Schemas.Revision[]

export type GetClusterRevisionsVariables = {
  pathParams: GetClusterRevisionsPathParams
} & V3ApiContext['fetcherOptions']

export const fetchGetClusterRevisions = (
  variables: GetClusterRevisionsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    GetClusterRevisionsResponse,
    GetClusterRevisionsError,
    undefined,
    {},
    {},
    GetClusterRevisionsPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions',
    method: 'get',
    ...variables,
    signal,
  })

export const useGetClusterRevisions = <TData = GetClusterRevisionsResponse>(
  variables: GetClusterRevisionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetClusterRevisionsResponse,
      GetClusterRevisionsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    GetClusterRevisionsResponse,
    GetClusterRevisionsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions',
      operationId: 'getClusterRevisions',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetClusterRevisions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type GetClusterRevisionRenderPathParams = {
  orgId: string
  clusterId: string
  revisionId: string
}

export type GetClusterRevisionRenderError = Fetcher.ErrorWrapper<undefined>

export type GetClusterRevisionRenderVariables = {
  pathParams: GetClusterRevisionRenderPathParams
} & V3ApiContext['fetcherOptions']

export const fetchGetClusterRevisionRender = (
  variables: GetClusterRevisionRenderVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.Template,
    GetClusterRevisionRenderError,
    undefined,
    {},
    {},
    GetClusterRevisionRenderPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revision/{revisionId}/render',
    method: 'get',
    ...variables,
    signal,
  })

export const useGetClusterRevisionRender = <TData = Schemas.Template>(
  variables: GetClusterRevisionRenderVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Template,
      GetClusterRevisionRenderError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.Template,
    GetClusterRevisionRenderError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revision/{revisionId}/render',
      operationId: 'getClusterRevisionRender',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetClusterRevisionRender(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  })
}

export type ApproveRevisionPathParams = {
  orgId: string
  clusterId: string
  revisionId: string
}

export type ApproveRevisionError = Fetcher.ErrorWrapper<undefined>

export type ApproveRevisionVariables = {
  body: Schemas.ApprovalRequest
  pathParams: ApproveRevisionPathParams
} & V3ApiContext['fetcherOptions']

export const fetchApproveRevision = (
  variables: ApproveRevisionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    ApproveRevisionError,
    Schemas.ApprovalRequest,
    {},
    {},
    ApproveRevisionPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}/approve',
    method: 'put',
    ...variables,
    signal,
  })

export const useApproveRevision = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      ApproveRevisionError,
      ApproveRevisionVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    ApproveRevisionError,
    ApproveRevisionVariables
  >({
    mutationFn: (variables: ApproveRevisionVariables) =>
      fetchApproveRevision({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type RejectRevisionPathParams = {
  orgId: string
  clusterId: string
  revisionId: string
}

export type RejectRevisionError = Fetcher.ErrorWrapper<undefined>

export type RejectRevisionVariables = {
  body: Schemas.ApprovalRequest
  pathParams: RejectRevisionPathParams
} & V3ApiContext['fetcherOptions']

export const fetchRejectRevision = (
  variables: RejectRevisionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    RejectRevisionError,
    Schemas.ApprovalRequest,
    {},
    {},
    RejectRevisionPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}/reject',
    method: 'put',
    ...variables,
    signal,
  })

export const useRejectRevision = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      RejectRevisionError,
      RejectRevisionVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    RejectRevisionError,
    RejectRevisionVariables
  >({
    mutationFn: (variables: RejectRevisionVariables) =>
      fetchRejectRevision({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type ApplyRevisionPathParams = {
  orgId: string
  clusterId: string
  revisionId: string
}

export type ApplyRevisionError = Fetcher.ErrorWrapper<undefined>

export type ApplyRevisionVariables = {
  body: Schemas.ApprovalRequest
  pathParams: ApplyRevisionPathParams
} & V3ApiContext['fetcherOptions']

export const fetchApplyRevision = (
  variables: ApplyRevisionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    ApplyRevisionError,
    Schemas.ApprovalRequest,
    {},
    {},
    ApplyRevisionPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}/apply',
    method: 'put',
    ...variables,
    signal,
  })

export const useApplyRevision = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      ApplyRevisionError,
      ApplyRevisionVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    ApplyRevisionError,
    ApplyRevisionVariables
  >({
    mutationFn: (variables: ApplyRevisionVariables) =>
      fetchApplyRevision({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type RollbackRevisionPathParams = {
  orgId: string
  clusterId: string
  revisionId: string
}

export type RollbackRevisionError = Fetcher.ErrorWrapper<undefined>

export type RollbackRevisionVariables = {
  body: Schemas.ApprovalRequest
  pathParams: RollbackRevisionPathParams
} & V3ApiContext['fetcherOptions']

export const fetchRollbackRevision = (
  variables: RollbackRevisionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    RollbackRevisionError,
    Schemas.ApprovalRequest,
    {},
    {},
    RollbackRevisionPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}/rollback',
    method: 'put',
    ...variables,
    signal,
  })

export const useRollbackRevision = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      RollbackRevisionError,
      RollbackRevisionVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    RollbackRevisionError,
    RollbackRevisionVariables
  >({
    mutationFn: (variables: RollbackRevisionVariables) =>
      fetchRollbackRevision({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetClusterSubscriptionPathParams = {
  orgId: string
  clusterId: string
}

export type GetClusterSubscriptionError = Fetcher.ErrorWrapper<undefined>

export type GetClusterSubscriptionVariables = {
  pathParams: GetClusterSubscriptionPathParams
} & V3ApiContext['fetcherOptions']

export const fetchGetClusterSubscription = (
  variables: GetClusterSubscriptionVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClusterSubscription,
    GetClusterSubscriptionError,
    undefined,
    {},
    {},
    GetClusterSubscriptionPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/subscription',
    method: 'get',
    ...variables,
    signal,
  })

export const useGetClusterSubscription = <TData = Schemas.ClusterSubscription>(
  variables: GetClusterSubscriptionVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ClusterSubscription,
      GetClusterSubscriptionError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.ClusterSubscription,
    GetClusterSubscriptionError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}/subscription',
      operationId: 'getClusterSubscription',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetClusterSubscription({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type DisarmSubscriptionsTrialError = Fetcher.ErrorWrapper<undefined>

export type DisarmSubscriptionsTrialVariables = {
  body: Schemas.DisarmTrialRequest
} & V3ApiContext['fetcherOptions']

/**
 * Admin-only cleanup tool for APP-1349 wave-2 trials. For each subscription id in the request,
 * sets `trial_settings.end_behavior.missing_payment_method` to `cancel` if and only if ALL of these hold:
 *   * the sub is currently in status `trialing`
 *   * the current `missing_payment_method` is `create_invoice`
 *   * `pause_collection` is null
 *   * `cancel_at_period_end` is false
 * Otherwise the per-sub outcome is `rejected` with a specific reason code (see DisarmTrialResult).
 * Partial success is normal; the caller reads the per-sub status array.
 */
export const fetchDisarmSubscriptionsTrial = (
  variables: DisarmSubscriptionsTrialVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.DisarmTrialBatchResponse,
    DisarmSubscriptionsTrialError,
    Schemas.DisarmTrialRequest,
    {},
    {},
    {}
  >({
    url: '/api/v3/subscriptions/disarm-trial',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Admin-only cleanup tool for APP-1349 wave-2 trials. For each subscription id in the request,
 * sets `trial_settings.end_behavior.missing_payment_method` to `cancel` if and only if ALL of these hold:
 *   * the sub is currently in status `trialing`
 *   * the current `missing_payment_method` is `create_invoice`
 *   * `pause_collection` is null
 *   * `cancel_at_period_end` is false
 * Otherwise the per-sub outcome is `rejected` with a specific reason code (see DisarmTrialResult).
 * Partial success is normal; the caller reads the per-sub status array.
 */
export const useDisarmSubscriptionsTrial = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DisarmTrialBatchResponse,
      DisarmSubscriptionsTrialError,
      DisarmSubscriptionsTrialVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.DisarmTrialBatchResponse,
    DisarmSubscriptionsTrialError,
    DisarmSubscriptionsTrialVariables
  >({
    mutationFn: (variables: DisarmSubscriptionsTrialVariables) =>
      fetchDisarmSubscriptionsTrial({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type CleanupTrialNoPmError = Fetcher.ErrorWrapper<undefined>

export type CleanupTrialNoPmVariables = {
  body: Schemas.CleanupTrialNoPmRequest
} & V3ApiContext['fetcherOptions']

/**
 * Admin-only cleanup tool for APP-1349 wave-2 Group-1 subs — subs that drifted past trial end
 * without a payment method anywhere on the customer. For each subscription id in the request:
 *   1. Validate against a strict Group-1 profile (status active|past_due, trial_end in past,
 *      end_behavior=create_invoice, no payment method on sub/customer/sibling sub, monthly plan,
 *      collection_method=charge_automatically, no pause_collection, not cancel_at_period_end,
 *      has clusterId+orgId metadata).
 *   2. Cancel the Stripe subscription with invoiceNow=false, prorate=false (wave-1 semantics).
 *   3. Call apicultor deleteBroker via gRPC to disable the hive (DB + k8s reconcile + 30-day grace).
 *   4. Best-effort void open + uncollectible invoices on the sub.
 * Any invariant failure → per-sub outcome `rejected` with a specific reason code. Partial
 * success (hive delete fails after cancel, or void fails after both) gets a distinct
 * non-rejected status. Callers read the per-sub result array.
 */
export const fetchCleanupTrialNoPm = (
  variables: CleanupTrialNoPmVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.CleanupTrialNoPmBatchResponse,
    CleanupTrialNoPmError,
    Schemas.CleanupTrialNoPmRequest,
    {},
    {},
    {}
  >({
    url: '/api/v3/subscriptions/cleanup-trial-no-pm',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Admin-only cleanup tool for APP-1349 wave-2 Group-1 subs — subs that drifted past trial end
 * without a payment method anywhere on the customer. For each subscription id in the request:
 *   1. Validate against a strict Group-1 profile (status active|past_due, trial_end in past,
 *      end_behavior=create_invoice, no payment method on sub/customer/sibling sub, monthly plan,
 *      collection_method=charge_automatically, no pause_collection, not cancel_at_period_end,
 *      has clusterId+orgId metadata).
 *   2. Cancel the Stripe subscription with invoiceNow=false, prorate=false (wave-1 semantics).
 *   3. Call apicultor deleteBroker via gRPC to disable the hive (DB + k8s reconcile + 30-day grace).
 *   4. Best-effort void open + uncollectible invoices on the sub.
 * Any invariant failure → per-sub outcome `rejected` with a specific reason code. Partial
 * success (hive delete fails after cancel, or void fails after both) gets a distinct
 * non-rejected status. Callers read the per-sub result array.
 */
export const useCleanupTrialNoPm = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CleanupTrialNoPmBatchResponse,
      CleanupTrialNoPmError,
      CleanupTrialNoPmVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.CleanupTrialNoPmBatchResponse,
    CleanupTrialNoPmError,
    CleanupTrialNoPmVariables
  >({
    mutationFn: (variables: CleanupTrialNoPmVariables) =>
      fetchCleanupTrialNoPm({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetClusterSecretPathParams = {
  orgId: string
  clusterId: string
}

export type GetClusterSecretError = Fetcher.ErrorWrapper<undefined>

export type GetClusterSecretResponse = {
  [key: string]: any
}

export type GetClusterSecretVariables = {
  pathParams: GetClusterSecretPathParams
} & V3ApiContext['fetcherOptions']

export const fetchGetClusterSecret = (
  variables: GetClusterSecretVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    GetClusterSecretResponse,
    GetClusterSecretError,
    undefined,
    {},
    {},
    GetClusterSecretPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/secrets',
    method: 'get',
    ...variables,
    signal,
  })

export const useGetClusterSecret = <TData = GetClusterSecretResponse>(
  variables: GetClusterSecretVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetClusterSecretResponse,
      GetClusterSecretError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    GetClusterSecretResponse,
    GetClusterSecretError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}/secrets',
      operationId: 'getClusterSecret',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetClusterSecret({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type PutClusterSecretPathParams = {
  orgId: string
  clusterId: string
}

export type PutClusterSecretError = Fetcher.ErrorWrapper<undefined>

export type PutClusterSecretRequestBody = {
  [key: string]: any
}

export type PutClusterSecretVariables = {
  body?: PutClusterSecretRequestBody
  pathParams: PutClusterSecretPathParams
} & V3ApiContext['fetcherOptions']

export const fetchPutClusterSecret = (
  variables: PutClusterSecretVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    PutClusterSecretError,
    PutClusterSecretRequestBody,
    {},
    {},
    PutClusterSecretPathParams
  >({
    url: '/api/v3/orgs/{orgId}/clusters/{clusterId}/secrets',
    method: 'put',
    ...variables,
    signal,
  })

export const usePutClusterSecret = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PutClusterSecretError,
      PutClusterSecretVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    undefined,
    PutClusterSecretError,
    PutClusterSecretVariables
  >({
    mutationFn: (variables: PutClusterSecretVariables) =>
      fetchPutClusterSecret({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetAllClustersRevisionsQueryParams = {
  /**
   * The page number for pagination.
   *
   * @format int32
   * @default 1
   */
  page?: number
  orgId?: string
  /**
   * @example submitted
   */
  approvalState?: 'submitted' | 'rejected' | 'approved' | 'applied'
  /**
   * @example asc
   * @default desc
   */
  order?: 'asc' | 'desc'
  hiveId?: string
  /**
   * Comma-separated list of organization-specific tags to filter clusters (OR logic)
   *
   * @example production,europe
   */
  tags?: string
  templateId?: string
  /**
   * Filter by hive state
   */
  hiveState?:
    | 'RUNNING'
    | 'PENDING'
    | 'ERROR'
    | 'DELETING'
    | 'LOCKED'
    | 'UNKNOWN'
  /**
   * Filter by apiary/deployment label ID
   *
   * @example apiary-a03-prod-eu-central-1
   */
  apiaryId?: string
  /**
   * Flag to include hives which are disabled (therefore no proper state and marked to be removed)
   *
   * @default false
   */
  includeDisabled?: boolean
  /**
   * Filter by cluster alias (case-insensitive partial match)
   *
   * @example prod
   */
  alias?: string
}

export type GetAllClustersRevisionsError = Fetcher.ErrorWrapper<undefined>

export type GetAllClustersRevisionsVariables = {
  queryParams?: GetAllClustersRevisionsQueryParams
} & V3ApiContext['fetcherOptions']

export const fetchGetAllClustersRevisions = (
  variables: GetAllClustersRevisionsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClustersRevisionsResponse,
    GetAllClustersRevisionsError,
    undefined,
    {},
    GetAllClustersRevisionsQueryParams,
    {}
  >({ url: '/api/v3/clusters', method: 'get', ...variables, signal })

export const useGetAllClustersRevisions = <
  TData = Schemas.ClustersRevisionsResponse,
>(
  variables: GetAllClustersRevisionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ClustersRevisionsResponse,
      GetAllClustersRevisionsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.ClustersRevisionsResponse,
    GetAllClustersRevisionsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/clusters',
      operationId: 'getAllClustersRevisions',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAllClustersRevisions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type ImportHivePathParams = {
  /**
   * The deployment label identifier
   */
  deploymentLabel: string
}

export type ImportHiveQueryParams = {
  /**
   * Associated subscription identifier
   */
  subscriptionId: string
  /**
   * Associated subscription identifier
   */
  templateId: string
}

export type ImportHiveError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * @example error
     */
    status?: string
    /**
     * @example Invalid YAML format
     */
    message?: string
  }
}>

export type ImportHiveResponse = {
  /**
   * @example success
   */
  status?: string
  /**
   * @example Configuration values applied successfully
   */
  message?: string
  /**
   * @example config-12345
   */
  id?: string
}

export type ImportHiveVariables = {
  pathParams: ImportHivePathParams
  queryParams: ImportHiveQueryParams
} & V3ApiContext['fetcherOptions']

/**
 * Creates or updates cluster configuration using YAML-formatted values
 */
export const fetchImportHive = (
  variables: ImportHiveVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    ImportHiveResponse,
    ImportHiveError,
    undefined,
    {},
    ImportHiveQueryParams,
    ImportHivePathParams
  >({
    url: '/api/v3/apiaries/{deploymentLabel}/valuesobject',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Creates or updates cluster configuration using YAML-formatted values
 */
export const useImportHive = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ImportHiveResponse,
      ImportHiveError,
      ImportHiveVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    ImportHiveResponse,
    ImportHiveError,
    ImportHiveVariables
  >({
    mutationFn: (variables: ImportHiveVariables) =>
      fetchImportHive({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetAuditLogsQueryParams = {
  /**
   * The page number for pagination.
   *
   * @format int32
   * @default 1
   */
  page?: number
  /**
   * Start timestamp (epoch time in milliseconds) to filter audit logs.
   *
   * @format int64
   */
  from?: number
  /**
   * End timestamp (epoch time in milliseconds) to filter audit logs.
   *
   * @format int64
   */
  to?: number
  /**
   * Optional Hive ID to filter logs based on the `hiveId` field in request metadata.
   */
  hiveId?: string
  /**
   * Optional Organization ID to filter logs based on the `orgId` field in request metadata.
   */
  orgId?: string
  /**
   * Optional username to filter logs by the user who performed the action.
   */
  user?: string
  /**
   * Optional User ID to filter logs based on the `userId` field in request metadata.
   */
  userId?: string
  /**
   * Filter by action status. **Exact match against the stored value**, which is why the
   * vocabulary is closed: an entry written with any other token (e.g. `failure`) is
   * unreachable through this filter, and a value outside the enum returns an empty list
   * rather than a `400`. Call sites writing audit entries must use exactly `success` or
   * `error`.
   */
  status?: 'success' | 'error'
  /**
   * Optional License ID to filter logs based on the `licenseId` field in request metadata.
   */
  licenseId?: string
  /**
   * Optional action to filter logs by the `action` field in request metadata. **Exact match** —
   * no prefix or OR matching, so a trail spanning several actions needs one call per action.
   *
   * Known values (a free string, not an enum, so this list grows without a contract change —
   * an unrecognised value simply matches nothing rather than erroring):
   *
   * | action | written by |
   * |---|---|
   * | `organization:link_salesforce_account` | `PUT /api/v3/orgs/{orgId}/salesforce-account` — first link, rebind, and every blocked attempt |
   * | `organization:unlink_salesforce_account` | `DELETE /api/v3/orgs/{orgId}/salesforce-account` — clear, and every blocked attempt |
   * | `organization:reprovision_pulse` | `POST /api/v3/pulse/reonboard` |
   * | `user_org:remove` | `DELETE /api/v3/orgs/{orgId}/users/{userId}` — the membership removal itself |
   * | `user_roles:clear` | the same call's best-effort RBAC role cleanup, audited separately so a cleanup that failed while the removal succeeded is reachable as `status=error` |
   *
   * Only operator actions that write `action` into their audit `requestMetadata` are
   * filterable here; an action absent from this list is not necessarily unaudited, just not
   * yet queryable by name.
   */
  action?: string
}

export type GetAuditLogsError = Fetcher.ErrorWrapper<undefined>

export type GetAuditLogsVariables = {
  queryParams?: GetAuditLogsQueryParams
} & V3ApiContext['fetcherOptions']

/**
 * Returns audit log entries, newest first, filtered by any combination of the query parameters
 * below. Filters are ANDed, and each is an **exact match** — there is no partial, prefix, or
 * OR matching (see the `action` note about multi-action trails).
 *
 * `orgId`, `action`, `hiveId`, `userId` and `licenseId` are matched against keys inside each
 * entry's `requestMetadata` JSON, so an action is only filterable by them if its call site
 * wrote that key. `user` and `status` are columns on the entry itself.
 *
 * ### Per-entity trails
 *
 * The intended shape is org + action, optionally narrowed by outcome:
 *
 * ```
 * # every Salesforce link event on an org (successes and blocked attempts)
 * ?orgId=abc123&action=organization:link_salesforce_account
 *
 * # only the ones that succeeded — the link actually changed
 * ?orgId=abc123&action=organization:link_salesforce_account&status=success
 *
 * # only the blocked attempts — refused rebinds, unconfirmed overwrites, validation failures
 * ?orgId=abc123&action=organization:link_salesforce_account&status=error
 * ```
 *
 * The `status=error` query is the security-relevant one: a *blocked* attempt is audited exactly
 * like a successful one, so it answers "who tried to rebind this org and was refused".
 *
 * **A full Salesforce trail needs two calls** — `action` is a single exact match, so link and
 * unlink must be fetched separately (`organization:link_salesforce_account` and
 * `organization:unlink_salesforce_account`) and merged client-side by timestamp. If that proves
 * awkward, the natural fix is comma-separated OR on `action`, mirroring the `tags` parameter
 * elsewhere in this API.
 *
 * ### Always pair `action` with `orgId`
 *
 * `timestamp`, `hiveId`, `orgId`, `userId`, `username` and `status` are all indexed, most of them
 * also as `(timestamp, …)` composites — so the per-entity trails above are index scans, not table
 * scans, and need no timestamp bound to perform.
 *
 * **`action` and `licenseId` are the exceptions: neither is indexed.** That is deliberate rather
 * than an oversight — `action` is designed to narrow an org's trail, so paired with `orgId` it is
 * applied as a cheap filter over the handful of rows the `orgId` index already returned. Filtering
 * on `action` **alone**, with no `orgId`, is the one shape that degrades to a sequential scan and
 * sort over the whole table:
 *
 * ```
 * ?orgId=abc123&action=organization:link_salesforce_account   # index scan on orgId — do this
 * ?action=organization:link_salesforce_account                # seq scan — avoid for UI/polling
 * ```
 *
 * A bounded `from` is a good habit for UI-facing lists regardless (it defaults to `0`, the epoch,
 * so omitting it means "all history"), but it is not load-bearing for an org-scoped trail.
 */
export const fetchGetAuditLogs = (
  variables: GetAuditLogsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.AuditLogsResponse,
    GetAuditLogsError,
    undefined,
    {},
    GetAuditLogsQueryParams,
    {}
  >({ url: '/api/v3/audit/logs', method: 'get', ...variables, signal })

/**
 * Returns audit log entries, newest first, filtered by any combination of the query parameters
 * below. Filters are ANDed, and each is an **exact match** — there is no partial, prefix, or
 * OR matching (see the `action` note about multi-action trails).
 *
 * `orgId`, `action`, `hiveId`, `userId` and `licenseId` are matched against keys inside each
 * entry's `requestMetadata` JSON, so an action is only filterable by them if its call site
 * wrote that key. `user` and `status` are columns on the entry itself.
 *
 * ### Per-entity trails
 *
 * The intended shape is org + action, optionally narrowed by outcome:
 *
 * ```
 * # every Salesforce link event on an org (successes and blocked attempts)
 * ?orgId=abc123&action=organization:link_salesforce_account
 *
 * # only the ones that succeeded — the link actually changed
 * ?orgId=abc123&action=organization:link_salesforce_account&status=success
 *
 * # only the blocked attempts — refused rebinds, unconfirmed overwrites, validation failures
 * ?orgId=abc123&action=organization:link_salesforce_account&status=error
 * ```
 *
 * The `status=error` query is the security-relevant one: a *blocked* attempt is audited exactly
 * like a successful one, so it answers "who tried to rebind this org and was refused".
 *
 * **A full Salesforce trail needs two calls** — `action` is a single exact match, so link and
 * unlink must be fetched separately (`organization:link_salesforce_account` and
 * `organization:unlink_salesforce_account`) and merged client-side by timestamp. If that proves
 * awkward, the natural fix is comma-separated OR on `action`, mirroring the `tags` parameter
 * elsewhere in this API.
 *
 * ### Always pair `action` with `orgId`
 *
 * `timestamp`, `hiveId`, `orgId`, `userId`, `username` and `status` are all indexed, most of them
 * also as `(timestamp, …)` composites — so the per-entity trails above are index scans, not table
 * scans, and need no timestamp bound to perform.
 *
 * **`action` and `licenseId` are the exceptions: neither is indexed.** That is deliberate rather
 * than an oversight — `action` is designed to narrow an org's trail, so paired with `orgId` it is
 * applied as a cheap filter over the handful of rows the `orgId` index already returned. Filtering
 * on `action` **alone**, with no `orgId`, is the one shape that degrades to a sequential scan and
 * sort over the whole table:
 *
 * ```
 * ?orgId=abc123&action=organization:link_salesforce_account   # index scan on orgId — do this
 * ?action=organization:link_salesforce_account                # seq scan — avoid for UI/polling
 * ```
 *
 * A bounded `from` is a good habit for UI-facing lists regardless (it defaults to `0`, the epoch,
 * so omitting it means "all history"), but it is not load-bearing for an org-scoped trail.
 */
export const useGetAuditLogs = <TData = Schemas.AuditLogsResponse>(
  variables: GetAuditLogsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AuditLogsResponse,
      GetAuditLogsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.AuditLogsResponse,
    GetAuditLogsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/audit/logs',
      operationId: 'getAuditLogs',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAuditLogs({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type GetProductCatalogError = Fetcher.ErrorWrapper<undefined>

export type GetProductCatalogVariables = V3ApiContext['fetcherOptions']

export const fetchGetProductCatalog = (
  variables: GetProductCatalogVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<Schemas.Products, GetProductCatalogError, undefined, {}, {}, {}>({
    url: '/api/v3/product/catalog',
    method: 'get',
    ...variables,
    signal,
  })

export const useGetProductCatalog = <TData = Schemas.Products>(
  variables: GetProductCatalogVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Products, GetProductCatalogError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<Schemas.Products, GetProductCatalogError, TData>({
    queryKey: queryKeyFn({
      path: '/api/v3/product/catalog',
      operationId: 'getProductCatalog',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetProductCatalog({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type PostTemplateError = Fetcher.ErrorWrapper<undefined>

export type PostTemplateVariables = {
  body: Schemas.NewTemplate
} & V3ApiContext['fetcherOptions']

export const fetchPostTemplate = (
  variables: PostTemplateVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.TemplateCreationResponse,
    PostTemplateError,
    Schemas.NewTemplate,
    {},
    {},
    {}
  >({
    url: '/api/v3/clusters/templates',
    method: 'post',
    ...variables,
    signal,
  })

export const usePostTemplate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TemplateCreationResponse,
      PostTemplateError,
      PostTemplateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.TemplateCreationResponse,
    PostTemplateError,
    PostTemplateVariables
  >({
    mutationFn: (variables: PostTemplateVariables) =>
      fetchPostTemplate({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetTemplatesQueryParams = {
  /**
   * The page number for pagination.
   *
   * @format int32
   * @default 1
   */
  page?: number
  /**
   * @example asc
   * @default desc
   */
  order?: 'asc' | 'desc'
  /**
   * @example Starter,Dedicated
   */
  tags?: string
  /**
   * Flag to include templates which are archived
   *
   * @default false
   */
  includeArchived?: boolean
}

export type GetTemplatesError = Fetcher.ErrorWrapper<undefined>

export type GetTemplatesVariables = {
  queryParams?: GetTemplatesQueryParams
} & V3ApiContext['fetcherOptions']

export const fetchGetTemplates = (
  variables: GetTemplatesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.TemplatesResponse,
    GetTemplatesError,
    undefined,
    {},
    GetTemplatesQueryParams,
    {}
  >({ url: '/api/v3/clusters/templates', method: 'get', ...variables, signal })

export const useGetTemplates = <TData = Schemas.TemplatesResponse>(
  variables: GetTemplatesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.TemplatesResponse,
      GetTemplatesError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.TemplatesResponse,
    GetTemplatesError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/clusters/templates',
      operationId: 'getTemplates',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetTemplates({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type GetTemplateByIdPathParams = {
  templateId: string
}

export type GetTemplateByIdError = Fetcher.ErrorWrapper<undefined>

export type GetTemplateByIdVariables = {
  pathParams: GetTemplateByIdPathParams
} & V3ApiContext['fetcherOptions']

export const fetchGetTemplateById = (
  variables: GetTemplateByIdVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.Template,
    GetTemplateByIdError,
    undefined,
    {},
    {},
    GetTemplateByIdPathParams
  >({
    url: '/api/v3/clusters/templates/{templateId}',
    method: 'get',
    ...variables,
    signal,
  })

export const useGetTemplateById = <TData = Schemas.Template>(
  variables: GetTemplateByIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Template, GetTemplateByIdError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<Schemas.Template, GetTemplateByIdError, TData>({
    queryKey: queryKeyFn({
      path: '/api/v3/clusters/templates/{templateId}',
      operationId: 'getTemplateById',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetTemplateById({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type ArchiveTemplatePathParams = {
  templateId: string
}

export type ArchiveTemplateError = Fetcher.ErrorWrapper<undefined>

export type ArchiveTemplateRequestBody = {
  /**
   * Indicates whether the template should be archived or not.
   */
  archived?: boolean
}

export type ArchiveTemplateVariables = {
  body?: ArchiveTemplateRequestBody
  pathParams: ArchiveTemplatePathParams
} & V3ApiContext['fetcherOptions']

export const fetchArchiveTemplate = (
  variables: ArchiveTemplateVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    ArchiveTemplateError,
    ArchiveTemplateRequestBody,
    {},
    {},
    ArchiveTemplatePathParams
  >({
    url: '/api/v3/clusters/templates/{templateId}/archive',
    method: 'put',
    ...variables,
    signal,
  })

export const useArchiveTemplate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ArchiveTemplateError,
      ArchiveTemplateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    undefined,
    ArchiveTemplateError,
    ArchiveTemplateVariables
  >({
    mutationFn: (variables: ArchiveTemplateVariables) =>
      fetchArchiveTemplate({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type UpdateTemplateTagsPathParams = {
  templateId: string
}

export type UpdateTemplateTagsError = Fetcher.ErrorWrapper<undefined>

export type UpdateTemplateTagsVariables = {
  body?: Schemas.Tags
  pathParams: UpdateTemplateTagsPathParams
} & V3ApiContext['fetcherOptions']

export const fetchUpdateTemplateTags = (
  variables: UpdateTemplateTagsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    UpdateTemplateTagsError,
    Schemas.Tags,
    {},
    {},
    UpdateTemplateTagsPathParams
  >({
    url: '/api/v3/clusters/templates/{templateId}/tags',
    method: 'put',
    ...variables,
    signal,
  })

export const useUpdateTemplateTags = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateTemplateTagsError,
      UpdateTemplateTagsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    undefined,
    UpdateTemplateTagsError,
    UpdateTemplateTagsVariables
  >({
    mutationFn: (variables: UpdateTemplateTagsVariables) =>
      fetchUpdateTemplateTags({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type RemoveSecretReferencesError = Fetcher.ErrorWrapper<undefined>

export type RemoveSecretReferencesResponse = {
  /**
   * A list of unique identifiers for the successfully processed hives.
   */
  hive_ids?: string[]
}

export type RemoveSecretReferencesRequestBody = {
  /**
   * A list of unique identifiers for the hives.
   */
  hive_ids: string[]
}

export type RemoveSecretReferencesVariables = {
  body: RemoveSecretReferencesRequestBody
} & V3ApiContext['fetcherOptions']

export const fetchRemoveSecretReferences = (
  variables: RemoveSecretReferencesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    RemoveSecretReferencesResponse,
    RemoveSecretReferencesError,
    RemoveSecretReferencesRequestBody,
    {},
    {},
    {}
  >({
    url: '/api/v3/clusters/removeSecretReferences',
    method: 'put',
    ...variables,
    signal,
  })

export const useRemoveSecretReferences = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      RemoveSecretReferencesResponse,
      RemoveSecretReferencesError,
      RemoveSecretReferencesVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    RemoveSecretReferencesResponse,
    RemoveSecretReferencesError,
    RemoveSecretReferencesVariables
  >({
    mutationFn: (variables: RemoveSecretReferencesVariables) =>
      fetchRemoveSecretReferences({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type ForceDeleteSecretsError = Fetcher.ErrorWrapper<undefined>

export type ForceDeleteSecretsResponse = {
  /**
   * A list of unique identifiers for the hives with successful deleted secrets.
   */
  hive_ids?: string[]
}

export type ForceDeleteSecretsRequestBody = {
  /**
   * A list of unique identifiers for the hives.
   */
  hive_ids: string[]
}

export type ForceDeleteSecretsVariables = {
  body: ForceDeleteSecretsRequestBody
} & V3ApiContext['fetcherOptions']

export const fetchForceDeleteSecrets = (
  variables: ForceDeleteSecretsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    ForceDeleteSecretsResponse,
    ForceDeleteSecretsError,
    ForceDeleteSecretsRequestBody,
    {},
    {},
    {}
  >({
    url: '/api/v3/clusters/forceDeleteSecrets',
    method: 'put',
    ...variables,
    signal,
  })

export const useForceDeleteSecrets = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ForceDeleteSecretsResponse,
      ForceDeleteSecretsError,
      ForceDeleteSecretsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    ForceDeleteSecretsResponse,
    ForceDeleteSecretsError,
    ForceDeleteSecretsVariables
  >({
    mutationFn: (variables: ForceDeleteSecretsVariables) =>
      fetchForceDeleteSecrets({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetRolloutsQueryParams = {
  /**
   * The page number for pagination.
   *
   * @format int32
   * @default 1
   */
  page?: number
  /**
   * @example asc
   * @default desc
   */
  order?: 'asc' | 'desc'
  /**
   * @example Starter,Dedicated
   */
  tags?: string
}

export type GetRolloutsError = Fetcher.ErrorWrapper<undefined>

export type GetRolloutsVariables = {
  queryParams?: GetRolloutsQueryParams
} & V3ApiContext['fetcherOptions']

export const fetchGetRollouts = (
  variables: GetRolloutsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.Rollouts,
    GetRolloutsError,
    undefined,
    {},
    GetRolloutsQueryParams,
    {}
  >({ url: '/api/v3/rollouts', method: 'get', ...variables, signal })

export const useGetRollouts = <TData = Schemas.Rollouts>(
  variables: GetRolloutsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Rollouts, GetRolloutsError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<Schemas.Rollouts, GetRolloutsError, TData>({
    queryKey: queryKeyFn({
      path: '/api/v3/rollouts',
      operationId: 'getRollouts',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetRollouts({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type SubmitRolloutError = Fetcher.ErrorWrapper<undefined>

export type SubmitRolloutVariables = {
  body: Schemas.RolloutSubmit
} & V3ApiContext['fetcherOptions']

export const fetchSubmitRollout = (
  variables: SubmitRolloutVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.RolloutResponse,
    SubmitRolloutError,
    Schemas.RolloutSubmit,
    {},
    {},
    {}
  >({ url: '/api/v3/rollouts', method: 'post', ...variables, signal })

export const useSubmitRollout = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RolloutResponse,
      SubmitRolloutError,
      SubmitRolloutVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.RolloutResponse,
    SubmitRolloutError,
    SubmitRolloutVariables
  >({
    mutationFn: (variables: SubmitRolloutVariables) =>
      fetchSubmitRollout({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type ApproveRolloutPathParams = {
  rolloutId: string
}

export type ApproveRolloutError = Fetcher.ErrorWrapper<undefined>

export type ApproveRolloutVariables = {
  body: Schemas.ApprovalRequest
  pathParams: ApproveRolloutPathParams
} & V3ApiContext['fetcherOptions']

export const fetchApproveRollout = (
  variables: ApproveRolloutVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    ApproveRolloutError,
    Schemas.ApprovalRequest,
    {},
    {},
    ApproveRolloutPathParams
  >({
    url: '/api/v3/rollouts/{rolloutId}/approve',
    method: 'put',
    ...variables,
    signal,
  })

export const useApproveRollout = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      ApproveRolloutError,
      ApproveRolloutVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    ApproveRolloutError,
    ApproveRolloutVariables
  >({
    mutationFn: (variables: ApproveRolloutVariables) =>
      fetchApproveRollout({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type RejectRolloutPathParams = {
  rolloutId: string
}

export type RejectRolloutError = Fetcher.ErrorWrapper<undefined>

export type RejectRolloutVariables = {
  body: Schemas.ApprovalRequest
  pathParams: RejectRolloutPathParams
} & V3ApiContext['fetcherOptions']

export const fetchRejectRollout = (
  variables: RejectRolloutVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    RejectRolloutError,
    Schemas.ApprovalRequest,
    {},
    {},
    RejectRolloutPathParams
  >({
    url: '/api/v3/rollouts/{rolloutId}/reject',
    method: 'put',
    ...variables,
    signal,
  })

export const useRejectRollout = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      RejectRolloutError,
      RejectRolloutVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    RejectRolloutError,
    RejectRolloutVariables
  >({
    mutationFn: (variables: RejectRolloutVariables) =>
      fetchRejectRollout({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type ExecuteRolloutPathParams = {
  rolloutId: string
}

export type ExecuteRolloutError = Fetcher.ErrorWrapper<undefined>

export type ExecuteRolloutVariables = {
  body: Schemas.ApprovalRequest
  pathParams: ExecuteRolloutPathParams
} & V3ApiContext['fetcherOptions']

export const fetchExecuteRollout = (
  variables: ExecuteRolloutVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    ExecuteRolloutError,
    Schemas.ApprovalRequest,
    {},
    {},
    ExecuteRolloutPathParams
  >({
    url: '/api/v3/rollouts/{rolloutId}/apply',
    method: 'put',
    ...variables,
    signal,
  })

export const useExecuteRollout = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      ExecuteRolloutError,
      ExecuteRolloutVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    ExecuteRolloutError,
    ExecuteRolloutVariables
  >({
    mutationFn: (variables: ExecuteRolloutVariables) =>
      fetchExecuteRollout({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type RollbackRolloutPathParams = {
  rolloutId: string
}

export type RollbackRolloutError = Fetcher.ErrorWrapper<undefined>

export type RollbackRolloutVariables = {
  body: Schemas.ApprovalRequest
  pathParams: RollbackRolloutPathParams
} & V3ApiContext['fetcherOptions']

export const fetchRollbackRollout = (
  variables: RollbackRolloutVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ApprovalResponse,
    RollbackRolloutError,
    Schemas.ApprovalRequest,
    {},
    {},
    RollbackRolloutPathParams
  >({
    url: '/api/v3/rollouts/{rolloutId}/rollback',
    method: 'put',
    ...variables,
    signal,
  })

export const useRollbackRollout = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApprovalResponse,
      RollbackRolloutError,
      RollbackRolloutVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ApprovalResponse,
    RollbackRolloutError,
    RollbackRolloutVariables
  >({
    mutationFn: (variables: RollbackRolloutVariables) =>
      fetchRollbackRollout({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetTagsQueryParams = {
  /**
   * The page number for pagination.
   *
   * @format int32
   * @default 1
   */
  page?: number
  /**
   * @example asc
   * @default desc
   */
  order?: 'asc' | 'desc'
  /**
   * @example Starter,Dedicated
   */
  tags?: string
}

export type GetTagsError = Fetcher.ErrorWrapper<undefined>

export type GetTagsVariables = {
  queryParams?: GetTagsQueryParams
} & V3ApiContext['fetcherOptions']

export const fetchGetTags = (
  variables: GetTagsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.TagsResponse,
    GetTagsError,
    undefined,
    {},
    GetTagsQueryParams,
    {}
  >({ url: '/api/v3/tags', method: 'get', ...variables, signal })

export const useGetTags = <TData = Schemas.TagsResponse>(
  variables: GetTagsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.TagsResponse, GetTagsError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<Schemas.TagsResponse, GetTagsError, TData>({
    queryKey: queryKeyFn({
      path: '/api/v3/tags',
      operationId: 'getTags',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetTags({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type GetMeteringRecordsPathParams = {
  orgId: string
  clusterId: string
}

export type GetMeteringRecordsQueryParams = {
  /**
   * Start date of the time range in format dd/mm/yyyy
   *
   * @format date
   * @pattern ^\\d{2}/\\d{2}/\\d{4}$
   */
  from: string
  /**
   * End date of the time range in format dd/mm/yyyy
   *
   * @format date
   * @pattern ^\\d{2}/\\d{2}/\\d{4}$
   */
  to: string
}

export type GetMeteringRecordsHeaders = {
  Accept:
    | 'application/json'
    | 'text/csv'
    | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}

export type GetMeteringRecordsError = Fetcher.ErrorWrapper<undefined>

export type GetMeteringRecordsVariables = {
  headers: GetMeteringRecordsHeaders
  pathParams: GetMeteringRecordsPathParams
  queryParams: GetMeteringRecordsQueryParams
} & V3ApiContext['fetcherOptions']

export const fetchGetMeteringRecords = (
  variables: GetMeteringRecordsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    string,
    GetMeteringRecordsError,
    undefined,
    GetMeteringRecordsHeaders,
    GetMeteringRecordsQueryParams,
    GetMeteringRecordsPathParams
  >({
    url: '/api/v3/orgs/{orgId}/metering/{clusterId}/records',
    method: 'get',
    ...variables,
    signal,
  })

export const useGetMeteringRecords = <TData = string>(
  variables: GetMeteringRecordsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<string, GetMeteringRecordsError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<string, GetMeteringRecordsError, TData>({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/metering/{clusterId}/records',
      operationId: 'getMeteringRecords',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetMeteringRecords({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type SearchOrganizationsQueryParams = {
  /**
   * The search term. Logically required: it must be 3–100 characters after trimming, else the
   * outcome is `invalid`. Any `q` containing `@` is an email or email-domain search.
   */
  q?: string
  /**
   * Maximum number of results, 1–50, default 25. A value out of range answers `invalid`; a
   * non-integer value is rejected by the framework with `400`.
   *
   * @format int32
   */
  limit?: number
}

export type SearchOrganizationsError = Fetcher.ErrorWrapper<undefined>

export type SearchOrganizationsVariables = {
  queryParams?: SearchOrganizationsQueryParams
} & V3ApiContext['fetcherOptions']

/**
 * Finds organizations by organization id, name, billing entity, Salesforce account id, owner or
 * member user id, or by the email (or part of the email) of an owner or member. Read-only and not
 * audited.
 *
 * **Routing.** A `q` containing `@` is an email search: a full email (exactly one `@`, a non-empty
 * part before it and a dot after it) is resolved to users with an exact Auth0 email search; any
 * other `q` containing `@` (for example `@acme.com`, `alice@`, `alice@acme`) with an email-only
 * partial Auth0 search. The resolved users' memberships and organizations are then read from
 * account-service. Every other `q` is passed through to account-service organization search.
 * An email-shaped `q` is never sent to account-service search.
 *
 * **Outcomes.** Every answer for an authorized caller is `200`; `outcome` names the state, and
 * `results` is empty for every outcome other than `ok`.
 *
 * | outcome | meaning |
 * |---|---|
 * | `ok` | The search ran. `results` may be empty. |
 * | `invalid` | `q` or `limit` is out of range, or account-service rejected the query. `message` says why. |
 * | `account_service_disabled` | account-service is not configured in this environment. |
 * | `error` | Auth0 or account-service could not be asked or failed. `message` says what failed. |
 *
 * Every `403` from account-service (in production, the WAF in front of it) is answered with
 * `error`.
 *
 * **Truncation.** `truncated` is `true` when more matches may exist than are returned. For a
 * passthrough search that is when the number of results equals `limit`. For an email search it is
 * when a cap was hit: 50 resolved users, 100 organizations, or the cut to `limit`.
 *
 * **Owner email.** `ownerEmail` is filled on a best-effort basis; when the lookup fails or times out
 * the results are returned without it.
 *
 * A non-integer `limit` is rejected by the framework with `400`, the only non-`200` answer for an
 * authorized caller.
 */
export const fetchSearchOrganizations = (
  variables: SearchOrganizationsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.OrgSearchResponse,
    SearchOrganizationsError,
    undefined,
    {},
    SearchOrganizationsQueryParams,
    {}
  >({ url: '/api/v3/search/orgs', method: 'get', ...variables, signal })

/**
 * Finds organizations by organization id, name, billing entity, Salesforce account id, owner or
 * member user id, or by the email (or part of the email) of an owner or member. Read-only and not
 * audited.
 *
 * **Routing.** A `q` containing `@` is an email search: a full email (exactly one `@`, a non-empty
 * part before it and a dot after it) is resolved to users with an exact Auth0 email search; any
 * other `q` containing `@` (for example `@acme.com`, `alice@`, `alice@acme`) with an email-only
 * partial Auth0 search. The resolved users' memberships and organizations are then read from
 * account-service. Every other `q` is passed through to account-service organization search.
 * An email-shaped `q` is never sent to account-service search.
 *
 * **Outcomes.** Every answer for an authorized caller is `200`; `outcome` names the state, and
 * `results` is empty for every outcome other than `ok`.
 *
 * | outcome | meaning |
 * |---|---|
 * | `ok` | The search ran. `results` may be empty. |
 * | `invalid` | `q` or `limit` is out of range, or account-service rejected the query. `message` says why. |
 * | `account_service_disabled` | account-service is not configured in this environment. |
 * | `error` | Auth0 or account-service could not be asked or failed. `message` says what failed. |
 *
 * Every `403` from account-service (in production, the WAF in front of it) is answered with
 * `error`.
 *
 * **Truncation.** `truncated` is `true` when more matches may exist than are returned. For a
 * passthrough search that is when the number of results equals `limit`. For an email search it is
 * when a cap was hit: 50 resolved users, 100 organizations, or the cut to `limit`.
 *
 * **Owner email.** `ownerEmail` is filled on a best-effort basis; when the lookup fails or times out
 * the results are returned without it.
 *
 * A non-integer `limit` is rejected by the framework with `400`, the only non-`200` answer for an
 * authorized caller.
 */
export const useSearchOrganizations = <TData = Schemas.OrgSearchResponse>(
  variables: SearchOrganizationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.OrgSearchResponse,
      SearchOrganizationsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.OrgSearchResponse,
    SearchOrganizationsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/search/orgs',
      operationId: 'searchOrganizations',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchSearchOrganizations({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type SearchUsersQueryParams = {
  /**
   * Search term to match against user email or name (partial match)
   *
   * @minLength 1
   */
  q: string
  /**
   * Zero-based page number for pagination
   *
   * @format int32
   * @default 0
   * @minimum 0
   */
  page?: number
  /**
   * Number of results per page (max 100)
   *
   * @format int32
   * @default 25
   * @minimum 1
   * @maximum 100
   */
  perPage?: number
}

export type SearchUsersError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * @example Search term must not be empty.
     */
    message?: string
  }
}>

export type SearchUsersVariables = {
  queryParams: SearchUsersQueryParams
} & V3ApiContext['fetcherOptions']

/**
 * Search for users using partial email or name match via Auth0. Supports pagination.
 */
export const fetchSearchUsers = (
  variables: SearchUsersVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.UserSearchResponse,
    SearchUsersError,
    undefined,
    {},
    SearchUsersQueryParams,
    {}
  >({ url: '/api/v3/users', method: 'get', ...variables, signal })

/**
 * Search for users using partial email or name match via Auth0. Supports pagination.
 */
export const useSearchUsers = <TData = Schemas.UserSearchResponse>(
  variables: SearchUsersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UserSearchResponse,
      SearchUsersError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.UserSearchResponse,
    SearchUsersError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/users',
      operationId: 'searchUsers',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchSearchUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type LookupUserIdentitiesQueryParams = {
  /**
   * Exact email to look up. Leading and trailing whitespace is trimmed and the match is
   * case-insensitive, including for identities Auth0 stored with mixed-case emails. An email that is not of the form `local@domain.tld` is rejected with 400.
   *
   * @minLength 1
   */
  email: string
}

export type LookupUserIdentitiesError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * @example Email is not valid.
     */
    message?: string
  }
}>

export type LookupUserIdentitiesVariables = {
  queryParams: LookupUserIdentitiesQueryParams
} & V3ApiContext['fetcherOptions']

/**
 * Returns every Auth0 user registered with exactly this email (case-insensitive), across all
 * connections (database, social and enterprise SSO), together with their platform state and the
 * SSO domain claim for the email's domain. Unlike `searchUsers`, which does a partial match, this
 * is an exact lookup. Read-only.
 *
 * Auth0's users-by-email lookup is case-sensitive, so the lower-cased email is combined with an
 * exact `email:"..."` user search (where Auth0 matches emails case-insensitively) and the results
 * are de-duplicated by user id. The users-by-email lookup is kept because the search index is
 * eventually consistent and may not yet contain a just-created user.
 *
 * Auth0 has no account linking, so one email can map to several separate users, each with its own
 * user id and memberships. `resolution` summarises what a caller may do with the email:
 *
 * | resolution | meaning |
 * |---|---|
 * | `NONE` | No identity exists and the domain is not SSO-claimed: a new user may be created. |
 * | `SINGLE` | Exactly one identity is selectable; it is returned as `suggestedUserId`. |
 * | `MULTIPLE` | More than one identity is selectable; the operator picks one. `suggestedUserId` is the selectable identity with the latest login. |
 * | `SSO_DOMAIN_NO_IDENTITY` | The domain is claimed by an active enterprise SSO connection and no enterprise identity of that connection exists for the email. Database or social identities are returned for visibility with `selectable=false`; a new database user must not be created. |
 * | `NO_SELECTABLE_IDENTITY` | Identities exist but none is selectable (e.g. only unverified database or social users, or enterprise users of an inactive connection) and the domain is not SSO-claimed. A new user must not be created either, since the email is already taken. |
 *
 * An identity is selectable when it can log in: enterprise identities only when their connection
 * is active, i.e. enabled for at least one application (email verification is not enforced for
 * them); database and social identities only when their email is verified. An enterprise identity
 * whose connection is inactive or unknown is never selectable. When the domain is SSO-claimed,
 * only enterprise identities of an active claiming connection are selectable.
 *
 * Claiming connections are checked one at a time, by connection name, and checking stops at the
 * first active one, after at most 10. The email's own identity connections are always checked.
 * `ssoDomainClaim` names the active claiming connection the email has an identity on, else the
 * first active claiming connection by name. When more than 10 connections claim the domain and
 * none of the first 10 by name is active, the domain is treated as claimed (fail closed):
 * `ssoDomainClaim` names the first claiming connection by name, which may be inactive.
 */
export const fetchLookupUserIdentities = (
  variables: LookupUserIdentitiesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.IdentityLookupResponse,
    LookupUserIdentitiesError,
    undefined,
    {},
    LookupUserIdentitiesQueryParams,
    {}
  >({ url: '/api/v3/users/lookup', method: 'get', ...variables, signal })

/**
 * Returns every Auth0 user registered with exactly this email (case-insensitive), across all
 * connections (database, social and enterprise SSO), together with their platform state and the
 * SSO domain claim for the email's domain. Unlike `searchUsers`, which does a partial match, this
 * is an exact lookup. Read-only.
 *
 * Auth0's users-by-email lookup is case-sensitive, so the lower-cased email is combined with an
 * exact `email:"..."` user search (where Auth0 matches emails case-insensitively) and the results
 * are de-duplicated by user id. The users-by-email lookup is kept because the search index is
 * eventually consistent and may not yet contain a just-created user.
 *
 * Auth0 has no account linking, so one email can map to several separate users, each with its own
 * user id and memberships. `resolution` summarises what a caller may do with the email:
 *
 * | resolution | meaning |
 * |---|---|
 * | `NONE` | No identity exists and the domain is not SSO-claimed: a new user may be created. |
 * | `SINGLE` | Exactly one identity is selectable; it is returned as `suggestedUserId`. |
 * | `MULTIPLE` | More than one identity is selectable; the operator picks one. `suggestedUserId` is the selectable identity with the latest login. |
 * | `SSO_DOMAIN_NO_IDENTITY` | The domain is claimed by an active enterprise SSO connection and no enterprise identity of that connection exists for the email. Database or social identities are returned for visibility with `selectable=false`; a new database user must not be created. |
 * | `NO_SELECTABLE_IDENTITY` | Identities exist but none is selectable (e.g. only unverified database or social users, or enterprise users of an inactive connection) and the domain is not SSO-claimed. A new user must not be created either, since the email is already taken. |
 *
 * An identity is selectable when it can log in: enterprise identities only when their connection
 * is active, i.e. enabled for at least one application (email verification is not enforced for
 * them); database and social identities only when their email is verified. An enterprise identity
 * whose connection is inactive or unknown is never selectable. When the domain is SSO-claimed,
 * only enterprise identities of an active claiming connection are selectable.
 *
 * Claiming connections are checked one at a time, by connection name, and checking stops at the
 * first active one, after at most 10. The email's own identity connections are always checked.
 * `ssoDomainClaim` names the active claiming connection the email has an identity on, else the
 * first active claiming connection by name. When more than 10 connections claim the domain and
 * none of the first 10 by name is active, the domain is treated as claimed (fail closed):
 * `ssoDomainClaim` names the first claiming connection by name, which may be inactive.
 */
export const useLookupUserIdentities = <TData = Schemas.IdentityLookupResponse>(
  variables: LookupUserIdentitiesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.IdentityLookupResponse,
      LookupUserIdentitiesError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.IdentityLookupResponse,
    LookupUserIdentitiesError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/users/lookup',
      operationId: 'lookupUserIdentities',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchLookupUserIdentities({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type GetUserRolesPathParams = {
  /**
   * User ID or "me" for the current authenticated user
   */
  userId: string
}

export type GetUserRolesError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: {
        /**
         * @example Invalid userId format.
         */
        message?: string
      }
    }
  | {
      status: 401
      payload: {
        /**
         * @example Authentication credentials were missing or incorrect.
         */
        message?: string
      }
    }
  | {
      status: 403
      payload: {
        /**
         * @example You do not have permission to access this resource.
         */
        message?: string
      }
    }
>

export type GetUserRolesVariables = {
  pathParams: GetUserRolesPathParams
} & V3ApiContext['fetcherOptions']

export const fetchGetUserRoles = (
  variables: GetUserRolesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.RoleList,
    GetUserRolesError,
    undefined,
    {},
    {},
    GetUserRolesPathParams
  >({
    url: '/api/v3/users/{userId}/roles',
    method: 'get',
    ...variables,
    signal,
  })

export const useGetUserRoles = <TData = Schemas.RoleList>(
  variables: GetUserRolesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.RoleList, GetUserRolesError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<Schemas.RoleList, GetUserRolesError, TData>({
    queryKey: queryKeyFn({
      path: '/api/v3/users/{userId}/roles',
      operationId: 'getUserRoles',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetUserRoles({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type GetUserDetailPathParams = {
  /**
   * Auth0 user ID
   */
  userId: string
}

export type GetUserDetailError = Fetcher.ErrorWrapper<undefined>

export type GetUserDetailVariables = {
  pathParams: GetUserDetailPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Retrieve detailed user information including activation status and organization memberships.
 */
export const fetchGetUserDetail = (
  variables: GetUserDetailVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.UserDetail,
    GetUserDetailError,
    undefined,
    {},
    {},
    GetUserDetailPathParams
  >({ url: '/api/v3/users/{userId}', method: 'get', ...variables, signal })

/**
 * Retrieve detailed user information including activation status and organization memberships.
 */
export const useGetUserDetail = <TData = Schemas.UserDetail>(
  variables: GetUserDetailVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.UserDetail, GetUserDetailError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<Schemas.UserDetail, GetUserDetailError, TData>({
    queryKey: queryKeyFn({
      path: '/api/v3/users/{userId}',
      operationId: 'getUserDetail',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetUserDetail({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type ActivateUserPathParams = {
  /**
   * Auth0 user ID
   */
  userId: string
}

export type ActivateUserError = Fetcher.ErrorWrapper<undefined>

export type ActivateUserVariables = {
  pathParams: ActivateUserPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Activates a user account by setting their email as verified.
 */
export const fetchActivateUser = (
  variables: ActivateUserVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ActivateUserResponse,
    ActivateUserError,
    undefined,
    {},
    {},
    ActivateUserPathParams
  >({
    url: '/api/v3/users/{userId}/activate',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Activates a user account by setting their email as verified.
 */
export const useActivateUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ActivateUserResponse,
      ActivateUserError,
      ActivateUserVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ActivateUserResponse,
    ActivateUserError,
    ActivateUserVariables
  >({
    mutationFn: (variables: ActivateUserVariables) =>
      fetchActivateUser({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type ResendActivationEmailPathParams = {
  /**
   * Auth0 user ID
   */
  userId: string
}

export type ResendActivationEmailError = Fetcher.ErrorWrapper<undefined>

export type ResendActivationEmailVariables = {
  pathParams: ResendActivationEmailPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Resends the activation/verification email to the user.
 */
export const fetchResendActivationEmail = (
  variables: ResendActivationEmailVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    undefined,
    ResendActivationEmailError,
    undefined,
    {},
    {},
    ResendActivationEmailPathParams
  >({
    url: '/api/v3/users/{userId}/resend-activation-email',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Resends the activation/verification email to the user.
 */
export const useResendActivationEmail = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ResendActivationEmailError,
      ResendActivationEmailVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    undefined,
    ResendActivationEmailError,
    ResendActivationEmailVariables
  >({
    mutationFn: (variables: ResendActivationEmailVariables) =>
      fetchResendActivationEmail({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type ListOrgLicensesPathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type ListOrgLicensesQueryParams = {
  /**
   * Filter by license status
   */
  status?: 'ACTIVE' | 'EXPIRED' | 'REVOKED'
  /**
   * Maximum number of results to return
   *
   * @minimum 1
   * @maximum 100
   * @default 50
   */
  limit?: number
  /**
   * Number of results to skip for pagination
   *
   * @minimum 0
   * @default 0
   */
  offset?: number
}

export type ListOrgLicensesError = Fetcher.ErrorWrapper<{
  status: 502
  payload: Schemas.ProblemDetailResponse
}>

export type ListOrgLicensesVariables = {
  pathParams: ListOrgLicensesPathParams
  queryParams?: ListOrgLicensesQueryParams
} & V3ApiContext['fetcherOptions']

/**
 * Returns all licenses belonging to the specified organisation. Delegates to hivemq-license-service.
 */
export const fetchListOrgLicenses = (
  variables: ListOrgLicensesVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.LicenseListResponse,
    ListOrgLicensesError,
    undefined,
    {},
    ListOrgLicensesQueryParams,
    ListOrgLicensesPathParams
  >({
    url: '/api/v3/orgs/{orgId}/licenses',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns all licenses belonging to the specified organisation. Delegates to hivemq-license-service.
 */
export const useListOrgLicenses = <TData = Schemas.LicenseListResponse>(
  variables: ListOrgLicensesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LicenseListResponse,
      ListOrgLicensesError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.LicenseListResponse,
    ListOrgLicensesError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/licenses',
      operationId: 'listOrgLicenses',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListOrgLicenses({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type CreateOrgLicensePathParams = {
  /**
   * Organisation ID
   */
  orgId: string
}

export type CreateOrgLicenseError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 502
      payload: Schemas.ProblemDetailResponse
    }
>

export type CreateOrgLicenseVariables = {
  body: Schemas.CreateLicenseRequestBody
  pathParams: CreateOrgLicensePathParams
} & V3ApiContext['fetcherOptions']

/**
 * Creates a new license for the specified organisation. The business motion (`origin`) is required; optional source traceability metadata may be supplied via `reference`. Delegates to hivemq-license-service.
 */
export const fetchCreateOrgLicense = (
  variables: CreateOrgLicenseVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.LicenseResponseBody,
    CreateOrgLicenseError,
    Schemas.CreateLicenseRequestBody,
    {},
    {},
    CreateOrgLicensePathParams
  >({
    url: '/api/v3/orgs/{orgId}/licenses',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Creates a new license for the specified organisation. The business motion (`origin`) is required; optional source traceability metadata may be supplied via `reference`. Delegates to hivemq-license-service.
 */
export const useCreateOrgLicense = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LicenseResponseBody,
      CreateOrgLicenseError,
      CreateOrgLicenseVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.LicenseResponseBody,
    CreateOrgLicenseError,
    CreateOrgLicenseVariables
  >({
    mutationFn: (variables: CreateOrgLicenseVariables) =>
      fetchCreateOrgLicense({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GetOrgLicensePathParams = {
  orgId: string
  /**
   * @format uuid
   */
  licenseId: string
}

export type GetOrgLicenseError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 502
      payload: Schemas.ProblemDetailResponse
    }
>

export type GetOrgLicenseVariables = {
  pathParams: GetOrgLicensePathParams
} & V3ApiContext['fetcherOptions']

/**
 * Returns a single license by ID within the specified organisation.
 */
export const fetchGetOrgLicense = (
  variables: GetOrgLicenseVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.LicenseResponseBody,
    GetOrgLicenseError,
    undefined,
    {},
    {},
    GetOrgLicensePathParams
  >({
    url: '/api/v3/orgs/{orgId}/licenses/{licenseId}',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns a single license by ID within the specified organisation.
 */
export const useGetOrgLicense = <TData = Schemas.LicenseResponseBody>(
  variables: GetOrgLicenseVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LicenseResponseBody,
      GetOrgLicenseError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.LicenseResponseBody,
    GetOrgLicenseError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/orgs/{orgId}/licenses/{licenseId}',
      operationId: 'getOrgLicense',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetOrgLicense({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type UpdateOrgLicenseEntitlementsPathParams = {
  orgId: string
  /**
   * @format uuid
   */
  licenseId: string
}

export type UpdateOrgLicenseEntitlementsError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 502
      payload: Schemas.ProblemDetailResponse
    }
>

export type UpdateOrgLicenseEntitlementsVariables = {
  body: Schemas.UpdateLicenseEntitlementsRequest
  pathParams: UpdateOrgLicenseEntitlementsPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Updates the connection and throughput limits for a license. Takes effect on the next broker /check call.
 */
export const fetchUpdateOrgLicenseEntitlements = (
  variables: UpdateOrgLicenseEntitlementsVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.LicenseResponseBody,
    UpdateOrgLicenseEntitlementsError,
    Schemas.UpdateLicenseEntitlementsRequest,
    {},
    {},
    UpdateOrgLicenseEntitlementsPathParams
  >({
    url: '/api/v3/orgs/{orgId}/licenses/{licenseId}/entitlements',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Updates the connection and throughput limits for a license. Takes effect on the next broker /check call.
 */
export const useUpdateOrgLicenseEntitlements = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LicenseResponseBody,
      UpdateOrgLicenseEntitlementsError,
      UpdateOrgLicenseEntitlementsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.LicenseResponseBody,
    UpdateOrgLicenseEntitlementsError,
    UpdateOrgLicenseEntitlementsVariables
  >({
    mutationFn: (variables: UpdateOrgLicenseEntitlementsVariables) =>
      fetchUpdateOrgLicenseEntitlements({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type UpdateOrgLicenseMetadataPathParams = {
  orgId: string
  /**
   * @format uuid
   */
  licenseId: string
}

export type UpdateOrgLicenseMetadataError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 422
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 502
      payload: Schemas.ProblemDetailResponse
    }
>

export type UpdateOrgLicenseMetadataVariables = {
  body?: Schemas.UpdateLicenseMetadataRequest
  pathParams: UpdateOrgLicenseMetadataPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Updates the name, description and/or reference of a license. At least one field required;
 * fields not included are left unchanged. Sending an empty string as `reference` clears it,
 * which is rejected with 422 unless the license origin is `self-service`.
 */
export const fetchUpdateOrgLicenseMetadata = (
  variables: UpdateOrgLicenseMetadataVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.LicenseResponseBody,
    UpdateOrgLicenseMetadataError,
    Schemas.UpdateLicenseMetadataRequest,
    {},
    {},
    UpdateOrgLicenseMetadataPathParams
  >({
    url: '/api/v3/orgs/{orgId}/licenses/{licenseId}/metadata',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Updates the name, description and/or reference of a license. At least one field required;
 * fields not included are left unchanged. Sending an empty string as `reference` clears it,
 * which is rejected with 422 unless the license origin is `self-service`.
 */
export const useUpdateOrgLicenseMetadata = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LicenseResponseBody,
      UpdateOrgLicenseMetadataError,
      UpdateOrgLicenseMetadataVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.LicenseResponseBody,
    UpdateOrgLicenseMetadataError,
    UpdateOrgLicenseMetadataVariables
  >({
    mutationFn: (variables: UpdateOrgLicenseMetadataVariables) =>
      fetchUpdateOrgLicenseMetadata({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type RevokeOrgLicensePathParams = {
  orgId: string
  /**
   * @format uuid
   */
  licenseId: string
}

export type RevokeOrgLicenseError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 502
      payload: Schemas.ProblemDetailResponse
    }
>

export type RevokeOrgLicenseVariables = {
  pathParams: RevokeOrgLicensePathParams
} & V3ApiContext['fetcherOptions']

/**
 * Revokes an active license. Idempotent — already-revoked licenses return 200.
 */
export const fetchRevokeOrgLicense = (
  variables: RevokeOrgLicenseVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.LicenseResponseBody,
    RevokeOrgLicenseError,
    undefined,
    {},
    {},
    RevokeOrgLicensePathParams
  >({
    url: '/api/v3/orgs/{orgId}/licenses/{licenseId}/revoke',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Revokes an active license. Idempotent — already-revoked licenses return 200.
 */
export const useRevokeOrgLicense = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LicenseResponseBody,
      RevokeOrgLicenseError,
      RevokeOrgLicenseVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.LicenseResponseBody,
    RevokeOrgLicenseError,
    RevokeOrgLicenseVariables
  >({
    mutationFn: (variables: RevokeOrgLicenseVariables) =>
      fetchRevokeOrgLicense({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type RenewOrgLicensePathParams = {
  orgId: string
  /**
   * @format uuid
   */
  licenseId: string
}

export type RenewOrgLicenseError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 502
      payload: Schemas.ProblemDetailResponse
    }
>

export type RenewOrgLicenseVariables = {
  body: Schemas.RenewLicenseRequest
  pathParams: RenewOrgLicensePathParams
} & V3ApiContext['fetcherOptions']

/**
 * Extends the validity end date of an active license.
 */
export const fetchRenewOrgLicense = (
  variables: RenewOrgLicenseVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.LicenseResponseBody,
    RenewOrgLicenseError,
    Schemas.RenewLicenseRequest,
    {},
    {},
    RenewOrgLicensePathParams
  >({
    url: '/api/v3/orgs/{orgId}/licenses/{licenseId}/renew',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Extends the validity end date of an active license.
 */
export const useRenewOrgLicense = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LicenseResponseBody,
      RenewOrgLicenseError,
      RenewOrgLicenseVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.LicenseResponseBody,
    RenewOrgLicenseError,
    RenewOrgLicenseVariables
  >({
    mutationFn: (variables: RenewOrgLicenseVariables) =>
      fetchRenewOrgLicense({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type ReactivateOrgLicensePathParams = {
  orgId: string
  /**
   * @format uuid
   */
  licenseId: string
}

export type ReactivateOrgLicenseError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 403
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 422
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 502
      payload: Schemas.ProblemDetailResponse
    }
>

export type ReactivateOrgLicenseVariables = {
  pathParams: ReactivateOrgLicensePathParams
} & V3ApiContext['fetcherOptions']

/**
 * Reactivates a REVOKED or EXPIRED license, flipping it back to ACTIVE. Idempotent — already-active licenses return 200 with reactivated=false. SLG licenses only; PLG licenses return 403.
 */
export const fetchReactivateOrgLicense = (
  variables: ReactivateOrgLicenseVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ReactivateLicenseResponseBody,
    ReactivateOrgLicenseError,
    undefined,
    {},
    {},
    ReactivateOrgLicensePathParams
  >({
    url: '/api/v3/orgs/{orgId}/licenses/{licenseId}/reactivate',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Reactivates a REVOKED or EXPIRED license, flipping it back to ACTIVE. Idempotent — already-active licenses return 200 with reactivated=false. SLG licenses only; PLG licenses return 403.
 */
export const useReactivateOrgLicense = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ReactivateLicenseResponseBody,
      ReactivateOrgLicenseError,
      ReactivateOrgLicenseVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ReactivateLicenseResponseBody,
    ReactivateOrgLicenseError,
    ReactivateOrgLicenseVariables
  >({
    mutationFn: (variables: ReactivateOrgLicenseVariables) =>
      fetchReactivateOrgLicense({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type RegenerateOrgLicenseBindingConnectionStringPathParams = {
  orgId: string
  /**
   * @format uuid
   */
  licenseId: string
  /**
   * Cluster ID of the binding whose connection string is rotated. Opaque to the console: it is relayed unparsed. license-service caps it at 255 characters and answers 400 for a longer one; that cap is deliberately not declared here, so an over-long id is refused upstream with a problem detail rather than by bean validation.
   */
  clusterId: string
}

export type RegenerateOrgLicenseBindingConnectionStringError =
  Fetcher.ErrorWrapper<
    | {
        status: 400
        payload: Schemas.ProblemDetailResponse
      }
    | {
        status: 404
        payload: Schemas.ProblemDetailResponse
      }
    | {
        status: 409
        payload: Schemas.ProblemDetailResponse
      }
    | {
        status: 500
        payload: Schemas.ProblemDetailResponse
      }
    | {
        status: 502
        payload: Schemas.ProblemDetailResponse
      }
    | {
        status: 503
        payload: Schemas.ProblemDetailResponse
      }
  >

export type RegenerateOrgLicenseBindingConnectionStringVariables = {
  pathParams: RegenerateOrgLicenseBindingConnectionStringPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Rotates the Data Intelligence connection string of a single cluster binding. license-service mints the new string against the binding's own agent, invalidates the previous one and stores the replacement in a single operation; the console mints nothing and never contacts the Data Intelligence coordinator.
 *
 * **Repeatable, not idempotent.** Every call issues a new connection string and invalidates the previous one, so calling it twice is not the same as calling it once.
 *
 * **Destructive for the binding's broker.** The broker keeps using the credential it last downloaded, so it is disconnected until it checks in again and picks up the replacement. Only the one cluster named by `clusterId` is affected; other bindings on the same license keep their own strings.
 *
 * The connection string itself is never returned. It is readable only by the broker, through the license-service public `/check` endpoint.
 *
 * Restricted to the `admin` role. Most license endpoints also admit `gtm`; this one and `backfillLicensePlans` are the two exceptions. This one excludes `gtm` because it disconnects the customer's broker.
 */
export const fetchRegenerateOrgLicenseBindingConnectionString = (
  variables: RegenerateOrgLicenseBindingConnectionStringVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.ClusterBinding,
    RegenerateOrgLicenseBindingConnectionStringError,
    undefined,
    {},
    {},
    RegenerateOrgLicenseBindingConnectionStringPathParams
  >({
    url: '/api/v3/orgs/{orgId}/licenses/{licenseId}/bindings/{clusterId}/connection-string',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Rotates the Data Intelligence connection string of a single cluster binding. license-service mints the new string against the binding's own agent, invalidates the previous one and stores the replacement in a single operation; the console mints nothing and never contacts the Data Intelligence coordinator.
 *
 * **Repeatable, not idempotent.** Every call issues a new connection string and invalidates the previous one, so calling it twice is not the same as calling it once.
 *
 * **Destructive for the binding's broker.** The broker keeps using the credential it last downloaded, so it is disconnected until it checks in again and picks up the replacement. Only the one cluster named by `clusterId` is affected; other bindings on the same license keep their own strings.
 *
 * The connection string itself is never returned. It is readable only by the broker, through the license-service public `/check` endpoint.
 *
 * Restricted to the `admin` role. Most license endpoints also admit `gtm`; this one and `backfillLicensePlans` are the two exceptions. This one excludes `gtm` because it disconnects the customer's broker.
 */
export const useRegenerateOrgLicenseBindingConnectionString = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ClusterBinding,
      RegenerateOrgLicenseBindingConnectionStringError,
      RegenerateOrgLicenseBindingConnectionStringVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.ClusterBinding,
    RegenerateOrgLicenseBindingConnectionStringError,
    RegenerateOrgLicenseBindingConnectionStringVariables
  >({
    mutationFn: (
      variables: RegenerateOrgLicenseBindingConnectionStringVariables,
    ) =>
      fetchRegenerateOrgLicenseBindingConnectionString({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  })
}

export type BackfillLicensePlansError = Fetcher.ErrorWrapper<{
  status: 400
  payload: Schemas.ProblemDetailResponse
}>

export type BackfillLicensePlansVariables = {
  body: Schemas.LicensePlanBackfillRequest
} & V3ApiContext['fetcherOptions']

/**
 * One-off operator action (APP-2310). Recovers `plan` for licenses created before the column existed, where the value survives only as the Stripe subscription's `tier` metadata — license-service never talks to Stripe, so it cannot do this itself.
 *
 * Per license: read it from license-service, fetch its Stripe subscription, take `metadata.tier`, and write it upstream through the write-once `POST /licenses/{licenseId}/plan-backfill`. Every license is processed independently and a mixed batch still returns 200; read the per-row `outcome`.
 *
 * **The plan is never inferred.** `10000/500` looks like Launch and `10000/1000` like Run, but a `custom` license can coincidentally match those numbers and the catalogue values may have moved since. A license whose subscription carries no `tier` is reported as `error_no_tier_metadata` and left untouched — a wrong plan is worse than a missing one once it drives billing UI and DWH reporting.
 *
 * **Safe to re-run.** The upstream write only fires where the stored plan is still null, so a second pass reports `skipped_plan_already_set` and changes nothing.
 *
 * Restricted to the `admin` role: this writes a field that drives billing UI and warehouse reporting, and upstream the write cannot be undone through `/plan` for licenses that have already expired.
 *
 * Callers get the batch from `SELECT org_id, id FROM licenses WHERE plan IS NULL AND subscription_id IS NOT NULL` — license-service exposes no cross-org query, and building one for a one-off is tracked instead as a friction entry on APP-2373.
 */
export const fetchBackfillLicensePlans = (
  variables: BackfillLicensePlansVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.LicensePlanBackfillReport,
    BackfillLicensePlansError,
    Schemas.LicensePlanBackfillRequest,
    {},
    {},
    {}
  >({
    url: '/api/v3/licenses/plan-backfill',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * One-off operator action (APP-2310). Recovers `plan` for licenses created before the column existed, where the value survives only as the Stripe subscription's `tier` metadata — license-service never talks to Stripe, so it cannot do this itself.
 *
 * Per license: read it from license-service, fetch its Stripe subscription, take `metadata.tier`, and write it upstream through the write-once `POST /licenses/{licenseId}/plan-backfill`. Every license is processed independently and a mixed batch still returns 200; read the per-row `outcome`.
 *
 * **The plan is never inferred.** `10000/500` looks like Launch and `10000/1000` like Run, but a `custom` license can coincidentally match those numbers and the catalogue values may have moved since. A license whose subscription carries no `tier` is reported as `error_no_tier_metadata` and left untouched — a wrong plan is worse than a missing one once it drives billing UI and DWH reporting.
 *
 * **Safe to re-run.** The upstream write only fires where the stored plan is still null, so a second pass reports `skipped_plan_already_set` and changes nothing.
 *
 * Restricted to the `admin` role: this writes a field that drives billing UI and warehouse reporting, and upstream the write cannot be undone through `/plan` for licenses that have already expired.
 *
 * Callers get the batch from `SELECT org_id, id FROM licenses WHERE plan IS NULL AND subscription_id IS NOT NULL` — license-service exposes no cross-org query, and building one for a one-off is tracked instead as a friction entry on APP-2373.
 */
export const useBackfillLicensePlans = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LicensePlanBackfillReport,
      BackfillLicensePlansError,
      BackfillLicensePlansVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.LicensePlanBackfillReport,
    BackfillLicensePlansError,
    BackfillLicensePlansVariables
  >({
    mutationFn: (variables: BackfillLicensePlansVariables) =>
      fetchBackfillLicensePlans({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type GrantLicenseMigrationEligibilityError = Fetcher.ErrorWrapper<{
  status: 400
  payload: Schemas.ProblemDetailResponse
}>

export type GrantLicenseMigrationEligibilityVariables = {
  body: Schemas.GrantLicenseMigrationEligibilityRequest
} & V3ApiContext['fetcherOptions']

/**
 * Support tooling for the Serverless migration license (APP-2795). Adds Auth0 user ids to `license_migration_eligibility` with `source = support-grant`, so a user who got the sunset email under a different login can claim the migration license.
 *
 * **Idempotent.** The insert is `ON CONFLICT DO NOTHING`: an id that already has a row, claimed or not, is counted in `alreadyPresent` and left untouched.
 *
 * Duplicate ids in the request are collapsed before the insert. The 1000-id cap applies to the raw list. Every successful grant is published to the audit log as `license:migration-eligibility-grant` with the reason and the granted ids.
 *
 * Restricted to the `admin` role.
 */
export const fetchGrantLicenseMigrationEligibility = (
  variables: GrantLicenseMigrationEligibilityVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.LicenseMigrationEligibilityGrantResponse,
    GrantLicenseMigrationEligibilityError,
    Schemas.GrantLicenseMigrationEligibilityRequest,
    {},
    {},
    {}
  >({
    url: '/api/v3/licenses/migration-eligibility',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Support tooling for the Serverless migration license (APP-2795). Adds Auth0 user ids to `license_migration_eligibility` with `source = support-grant`, so a user who got the sunset email under a different login can claim the migration license.
 *
 * **Idempotent.** The insert is `ON CONFLICT DO NOTHING`: an id that already has a row, claimed or not, is counted in `alreadyPresent` and left untouched.
 *
 * Duplicate ids in the request are collapsed before the insert. The 1000-id cap applies to the raw list. Every successful grant is published to the audit log as `license:migration-eligibility-grant` with the reason and the granted ids.
 *
 * Restricted to the `admin` role.
 */
export const useGrantLicenseMigrationEligibility = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LicenseMigrationEligibilityGrantResponse,
      GrantLicenseMigrationEligibilityError,
      GrantLicenseMigrationEligibilityVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.LicenseMigrationEligibilityGrantResponse,
    GrantLicenseMigrationEligibilityError,
    GrantLicenseMigrationEligibilityVariables
  >({
    mutationFn: (variables: GrantLicenseMigrationEligibilityVariables) =>
      fetchGrantLicenseMigrationEligibility({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  })
}

export type GetLicenseMigrationEligibilityPathParams = {
  /**
   * Auth0 user id, URL-encoded
   */
  userId: string
}

export type GetLicenseMigrationEligibilityError =
  Fetcher.ErrorWrapper<undefined>

export type GetLicenseMigrationEligibilityVariables = {
  pathParams: GetLicenseMigrationEligibilityPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Returns whether the user is on the Serverless migration license eligibility list and, when they have claimed, the claim state. A user without a row answers 200 with `eligible: false` and no other fields.
 *
 * A row with `claimedAt` set and no `licenseId` is a pending claim: the license may still be in flight, or the claim stalled after reserving.
 *
 * Restricted to the `admin` and `gtm` roles. The `userId` is an Auth0 user id and must be URL-encoded (`auth0|abc` becomes `auth0%7Cabc`).
 */
export const fetchGetLicenseMigrationEligibility = (
  variables: GetLicenseMigrationEligibilityVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.LicenseMigrationEligibilityResponse,
    GetLicenseMigrationEligibilityError,
    undefined,
    {},
    {},
    GetLicenseMigrationEligibilityPathParams
  >({
    url: '/api/v3/licenses/migration-eligibility/{userId}',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns whether the user is on the Serverless migration license eligibility list and, when they have claimed, the claim state. A user without a row answers 200 with `eligible: false` and no other fields.
 *
 * A row with `claimedAt` set and no `licenseId` is a pending claim: the license may still be in flight, or the claim stalled after reserving.
 *
 * Restricted to the `admin` and `gtm` roles. The `userId` is an Auth0 user id and must be URL-encoded (`auth0|abc` becomes `auth0%7Cabc`).
 */
export const useGetLicenseMigrationEligibility = <
  TData = Schemas.LicenseMigrationEligibilityResponse,
>(
  variables: GetLicenseMigrationEligibilityVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LicenseMigrationEligibilityResponse,
      GetLicenseMigrationEligibilityError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useV3ApiContext(options)
  return reactQuery.useQuery<
    Schemas.LicenseMigrationEligibilityResponse,
    GetLicenseMigrationEligibilityError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/v3/licenses/migration-eligibility/{userId}',
      operationId: 'getLicenseMigrationEligibility',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetLicenseMigrationEligibility(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  })
}

export type ResetLicenseMigrationClaimPathParams = {
  /**
   * Auth0 user id, URL-encoded
   */
  userId: string
}

export type ResetLicenseMigrationClaimError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 404
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 409
      payload: Schemas.ProblemDetailResponse
    }
>

export type ResetLicenseMigrationClaimVariables = {
  body: Schemas.ResetLicenseMigrationClaimRequest
  pathParams: ResetLicenseMigrationClaimPathParams
} & V3ApiContext['fetcherOptions']

/**
 * Clears `claimedAt`, `claimedOrgId`, `claimedByUserId` and `licenseId` on the user's eligibility row so they can claim again, for example after claiming into the wrong organization or losing the claimed license.
 *
 * **The previously claimed license is not deleted.** The response and the `license:migration-claim-reset` audit event carry its id and organization, so support can revoke it separately if wanted.
 *
 * A pending claim (`claimedAt` set, no `licenseId`) can be reset. Restricted to the `admin` role. The `userId` must be URL-encoded.
 */
export const fetchResetLicenseMigrationClaim = (
  variables: ResetLicenseMigrationClaimVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.LicenseMigrationClaimResetResponse,
    ResetLicenseMigrationClaimError,
    Schemas.ResetLicenseMigrationClaimRequest,
    {},
    {},
    ResetLicenseMigrationClaimPathParams
  >({
    url: '/api/v3/licenses/migration-eligibility/{userId}/reset',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Clears `claimedAt`, `claimedOrgId`, `claimedByUserId` and `licenseId` on the user's eligibility row so they can claim again, for example after claiming into the wrong organization or losing the claimed license.
 *
 * **The previously claimed license is not deleted.** The response and the `license:migration-claim-reset` audit event carry its id and organization, so support can revoke it separately if wanted.
 *
 * A pending claim (`claimedAt` set, no `licenseId`) can be reset. Restricted to the `admin` role. The `userId` must be URL-encoded.
 */
export const useResetLicenseMigrationClaim = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LicenseMigrationClaimResetResponse,
      ResetLicenseMigrationClaimError,
      ResetLicenseMigrationClaimVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.LicenseMigrationClaimResetResponse,
    ResetLicenseMigrationClaimError,
    ResetLicenseMigrationClaimVariables
  >({
    mutationFn: (variables: ResetLicenseMigrationClaimVariables) =>
      fetchResetLicenseMigrationClaim({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type ResolveSalesforceOpportunityError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 503
      payload: Schemas.ProblemDetailResponse
    }
>

export type ResolveSalesforceOpportunityVariables = {
  body?: Schemas.SalesforceOpportunityResolveRequest
} & V3ApiContext['fetcherOptions']

/**
 * Second entry point onto the Salesforce ingest orchestration, for the case the machine could not
 * decide. An operator pastes the payload block from a needs-attention message, adds the decision
 * the ingest could not make (`createNewOrg`, `createNewAccount`, `orgId`, `reason`) and submits it.
 *
 * The path sits deliberately outside `/api/v3/salesforce/**`: that glob belongs to the Salesforce
 * M2M ingest filter, which would reject an operator's Okta token before RBAC ran (APP-2424 set the
 * same precedent for the reverse account lookup).
 *
 * **Async by design**, exactly like the ingest route: the resolution is validated, acknowledged with
 * `202` and an `ingestId`, and orchestrated fire-and-forget. Delivering the licences is up to 100
 * sequential calls, so the response cannot carry the outcome — the operator learns it from the
 * needs-attention channel and the outcome log line.
 *
 * Licences already delivered for the opportunity into the target organization are counted before
 * anything is created, so a re-submitted resolution completes the set rather than duplicating it.
 */
export const fetchResolveSalesforceOpportunity = (
  variables: ResolveSalesforceOpportunityVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.SalesforceOpportunityIngestResponse,
    ResolveSalesforceOpportunityError,
    Schemas.SalesforceOpportunityResolveRequest,
    {},
    {},
    {}
  >({
    url: '/api/v3/salesforce-opportunities/resolve',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Second entry point onto the Salesforce ingest orchestration, for the case the machine could not
 * decide. An operator pastes the payload block from a needs-attention message, adds the decision
 * the ingest could not make (`createNewOrg`, `createNewAccount`, `orgId`, `reason`) and submits it.
 *
 * The path sits deliberately outside `/api/v3/salesforce/**`: that glob belongs to the Salesforce
 * M2M ingest filter, which would reject an operator's Okta token before RBAC ran (APP-2424 set the
 * same precedent for the reverse account lookup).
 *
 * **Async by design**, exactly like the ingest route: the resolution is validated, acknowledged with
 * `202` and an `ingestId`, and orchestrated fire-and-forget. Delivering the licences is up to 100
 * sequential calls, so the response cannot carry the outcome — the operator learns it from the
 * needs-attention channel and the outcome log line.
 *
 * Licences already delivered for the opportunity into the target organization are counted before
 * anything is created, so a re-submitted resolution completes the set rather than duplicating it.
 */
export const useResolveSalesforceOpportunity = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SalesforceOpportunityIngestResponse,
      ResolveSalesforceOpportunityError,
      ResolveSalesforceOpportunityVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.SalesforceOpportunityIngestResponse,
    ResolveSalesforceOpportunityError,
    ResolveSalesforceOpportunityVariables
  >({
    mutationFn: (variables: ResolveSalesforceOpportunityVariables) =>
      fetchResolveSalesforceOpportunity({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type CreateAccountError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 409
      payload: Schemas.CreateAccountConflictResponse
    }
  | {
      status: 500
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 502
      payload: Schemas.ProblemDetailResponse
    }
  | {
      status: 503
      payload: Schemas.ProblemDetailResponse
    }
>

export type CreateAccountVariables = {
  body: Schemas.CreateAccountRequest
} & V3ApiContext['fetcherOptions']

/**
 * Creates a new organization for an owner, optionally with up to 10 additional members, in one
 * synchronous call. Used by sales to stand up a customer before a license is issued.
 *
 * **Owner.** Before anything is created, the owner's `authEmail` is resolved with the identity
 * lookup rules (`GET /api/v3/users/lookup`), and the owner is classified (first match wins):
 *
 * | Request | Resolution | Result |
 * | -- | -- | -- |
 * | no `ownerUserId` | no identity, domain not SSO-claimed | new owner: `400` if `firstName` or `lastName` is blank, else a new Auth0 user, account and organization (`owner.outcome = CREATED`) |
 * | no `ownerUserId` | no identity, domain SSO-claimed | `409` `OWNER_SSO_DOMAIN_NO_IDENTITY` |
 * | no `ownerUserId` | at least one identity, of any connection type | `409` `OWNER_EXISTS` with `identities` |
 * | `ownerUserId` | not an identity of `authEmail` | `400` |
 * | `ownerUserId` | the identity is not selectable and the domain is SSO-claimed | `409` `OWNER_SSO_DOMAIN_NO_IDENTITY` |
 * | `ownerUserId` | the identity is not selectable and the domain is not SSO-claimed | `409` `OWNER_NOT_SELECTABLE` |
 * | `ownerUserId` | the identity is selectable | existing owner: a new organization owned by that identity (`owner.outcome = ATTACHED_EXISTING`) |
 *
 * **Billing.** Every organization created here gets its own new Stripe customer, named after
 * `company`. An existing owner's Stripe customer is never used or changed.
 *
 * **Owner email.** After the organization exists, the owner gets one invite email: a set-password
 * link for a new owner, a link to the organization for an existing one. `owner.emailSent` reports
 * whether SendGrid accepted it; an email failure never fails the request.
 *
 * **Additional members.** `additionalMembers` are added after the owner email with the same rules
 * as `POST /api/v3/orgs/{orgId}/members`. A member failure never rolls back the organization. When
 * the members step fails as a whole, the response is still `201` and every requested member is
 * reported `FAILED` with reason `LOOKUP_FAILED`; retry them with `POST /api/v3/orgs/{orgId}/members`.
 *
 * **Errors.** Every validation, lookup and classification rejection happens before anything is
 * created. After any `409`, nothing created by this request remains. A failure while creating the
 * owner or the organization undoes what the request created and returns `500`.
 *
 * **Retries.** The existing-owner path is not idempotent: retrying a request with `ownerUserId`
 * after a timeout or `5xx` can create a second organization and Stripe customer. Check the owner's
 * organizations before retrying.
 */
export const fetchCreateAccount = (
  variables: CreateAccountVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.CreateAccountResponse,
    CreateAccountError,
    Schemas.CreateAccountRequest,
    {},
    {},
    {}
  >({ url: '/api/v3/accounts', method: 'post', ...variables, signal })

/**
 * Creates a new organization for an owner, optionally with up to 10 additional members, in one
 * synchronous call. Used by sales to stand up a customer before a license is issued.
 *
 * **Owner.** Before anything is created, the owner's `authEmail` is resolved with the identity
 * lookup rules (`GET /api/v3/users/lookup`), and the owner is classified (first match wins):
 *
 * | Request | Resolution | Result |
 * | -- | -- | -- |
 * | no `ownerUserId` | no identity, domain not SSO-claimed | new owner: `400` if `firstName` or `lastName` is blank, else a new Auth0 user, account and organization (`owner.outcome = CREATED`) |
 * | no `ownerUserId` | no identity, domain SSO-claimed | `409` `OWNER_SSO_DOMAIN_NO_IDENTITY` |
 * | no `ownerUserId` | at least one identity, of any connection type | `409` `OWNER_EXISTS` with `identities` |
 * | `ownerUserId` | not an identity of `authEmail` | `400` |
 * | `ownerUserId` | the identity is not selectable and the domain is SSO-claimed | `409` `OWNER_SSO_DOMAIN_NO_IDENTITY` |
 * | `ownerUserId` | the identity is not selectable and the domain is not SSO-claimed | `409` `OWNER_NOT_SELECTABLE` |
 * | `ownerUserId` | the identity is selectable | existing owner: a new organization owned by that identity (`owner.outcome = ATTACHED_EXISTING`) |
 *
 * **Billing.** Every organization created here gets its own new Stripe customer, named after
 * `company`. An existing owner's Stripe customer is never used or changed.
 *
 * **Owner email.** After the organization exists, the owner gets one invite email: a set-password
 * link for a new owner, a link to the organization for an existing one. `owner.emailSent` reports
 * whether SendGrid accepted it; an email failure never fails the request.
 *
 * **Additional members.** `additionalMembers` are added after the owner email with the same rules
 * as `POST /api/v3/orgs/{orgId}/members`. A member failure never rolls back the organization. When
 * the members step fails as a whole, the response is still `201` and every requested member is
 * reported `FAILED` with reason `LOOKUP_FAILED`; retry them with `POST /api/v3/orgs/{orgId}/members`.
 *
 * **Errors.** Every validation, lookup and classification rejection happens before anything is
 * created. After any `409`, nothing created by this request remains. A failure while creating the
 * owner or the organization undoes what the request created and returns `500`.
 *
 * **Retries.** The existing-owner path is not idempotent: retrying a request with `ownerUserId`
 * after a timeout or `5xx` can create a second organization and Stripe customer. Check the owner's
 * organizations before retrying.
 */
export const useCreateAccount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CreateAccountResponse,
      CreateAccountError,
      CreateAccountVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.CreateAccountResponse,
    CreateAccountError,
    CreateAccountVariables
  >({
    mutationFn: (variables: CreateAccountVariables) =>
      fetchCreateAccount({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type IngestSalesforceOpportunityError = Fetcher.ErrorWrapper<{
  status: 400
  payload: Schemas.ProblemDetailResponse
}>

export type IngestSalesforceOpportunityVariables = {
  body: Schemas.SalesforceOpportunityIngestRequest
} & V3ApiContext['fetcherOptions']

/**
 * Salesforce posts a closed opportunity at Stage 6. The platform ACKs immediately (202 + ingestId)
 * and orchestrates account/org/licence creation asynchronously. Authenticated by a route-scoped
 * Auth0 M2M filter (scope provision:platform-licenses), not the backoffice admin RBAC — see APP-2144.
 */
export const fetchIngestSalesforceOpportunity = (
  variables: IngestSalesforceOpportunityVariables,
  signal?: AbortSignal,
) =>
  v3ApiFetch<
    Schemas.SalesforceOpportunityIngestResponse,
    IngestSalesforceOpportunityError,
    Schemas.SalesforceOpportunityIngestRequest,
    {},
    {},
    {}
  >({
    url: '/api/v3/salesforce/opportunities',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Salesforce posts a closed opportunity at Stage 6. The platform ACKs immediately (202 + ingestId)
 * and orchestrates account/org/licence creation asynchronously. Authenticated by a route-scoped
 * Auth0 M2M filter (scope provision:platform-licenses), not the backoffice admin RBAC — see APP-2144.
 */
export const useIngestSalesforceOpportunity = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SalesforceOpportunityIngestResponse,
      IngestSalesforceOpportunityError,
      IngestSalesforceOpportunityVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useV3ApiContext()
  return reactQuery.useMutation<
    Schemas.SalesforceOpportunityIngestResponse,
    IngestSalesforceOpportunityError,
    IngestSalesforceOpportunityVariables
  >({
    mutationFn: (variables: IngestSalesforceOpportunityVariables) =>
      fetchIngestSalesforceOpportunity({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type QueryOperation =
  | {
      path: '/api/v3/orgs/{orgId}/features'
      operationId: 'getOrganisationFeatures'
      variables: GetOrganisationFeaturesVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/addons/{addonId}/usage'
      operationId: 'getAddonUsage'
      variables: GetAddonUsageVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/salesforce-account'
      operationId: 'getSalesforceAccount'
      variables: GetSalesforceAccountVariables
    }
  | {
      path: '/api/v3/salesforce-accounts/{salesforceAccountId}/orgs'
      operationId: 'listOrganizationsBySalesforceAccount'
      variables: ListOrganizationsBySalesforceAccountVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/users'
      operationId: 'getOrgUsers'
      variables: GetOrgUsersVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/roles'
      operationId: 'getOrgRoles'
      variables: GetOrgRolesVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/support-users'
      operationId: 'listSupportUsers'
      variables: ListSupportUsersVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/tags'
      operationId: 'getOrganizationClusterTags'
      variables: GetOrganizationClusterTagsVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/idpConnections'
      operationId: 'getOrganisationIdpConnections'
      variables: GetOrganisationIdpConnectionsVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}'
      operationId: 'getCluster'
      variables: GetClusterVariables
    }
  | {
      path: '/api/v3/clusters/bulk-update/details'
      operationId: 'getBulkClusterUpdatesDetails'
      variables: GetBulkClusterUpdatesDetailsVariables
    }
  | {
      path: '/api/v3/clusters/bulk-update'
      operationId: 'getBulkClusterUpdates'
      variables: GetBulkClusterUpdatesVariables
    }
  | {
      path: '/api/v3/clusters/bulk-update/{bulkUpdateId}'
      operationId: 'getBulkClusterUpdateDetails'
      variables: GetBulkClusterUpdateDetailsVariables
    }
  | {
      path: '/api/v3/apiaries'
      operationId: 'getApiaries'
      variables: GetApiariesVariables
    }
  | {
      path: '/api/v3/clusters/extensions'
      operationId: 'getSupportedExtensions'
      variables: GetSupportedExtensionsVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions/{revisionId}'
      operationId: 'getClusterRevisionById'
      variables: GetClusterRevisionByIdVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}/applied'
      operationId: 'getClusterAppliedRevision'
      variables: GetClusterAppliedRevisionVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revisions'
      operationId: 'getClusterRevisions'
      variables: GetClusterRevisionsVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}/revision/{revisionId}/render'
      operationId: 'getClusterRevisionRender'
      variables: GetClusterRevisionRenderVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}/subscription'
      operationId: 'getClusterSubscription'
      variables: GetClusterSubscriptionVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/clusters/{clusterId}/secrets'
      operationId: 'getClusterSecret'
      variables: GetClusterSecretVariables
    }
  | {
      path: '/api/v3/clusters'
      operationId: 'getAllClustersRevisions'
      variables: GetAllClustersRevisionsVariables
    }
  | {
      path: '/api/v3/audit/logs'
      operationId: 'getAuditLogs'
      variables: GetAuditLogsVariables
    }
  | {
      path: '/api/v3/product/catalog'
      operationId: 'getProductCatalog'
      variables: GetProductCatalogVariables
    }
  | {
      path: '/api/v3/clusters/templates'
      operationId: 'getTemplates'
      variables: GetTemplatesVariables
    }
  | {
      path: '/api/v3/clusters/templates/{templateId}'
      operationId: 'getTemplateById'
      variables: GetTemplateByIdVariables
    }
  | {
      path: '/api/v3/rollouts'
      operationId: 'getRollouts'
      variables: GetRolloutsVariables
    }
  | {
      path: '/api/v3/tags'
      operationId: 'getTags'
      variables: GetTagsVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/metering/{clusterId}/records'
      operationId: 'getMeteringRecords'
      variables: GetMeteringRecordsVariables
    }
  | {
      path: '/api/v3/search/orgs'
      operationId: 'searchOrganizations'
      variables: SearchOrganizationsVariables
    }
  | {
      path: '/api/v3/users'
      operationId: 'searchUsers'
      variables: SearchUsersVariables
    }
  | {
      path: '/api/v3/users/lookup'
      operationId: 'lookupUserIdentities'
      variables: LookupUserIdentitiesVariables
    }
  | {
      path: '/api/v3/users/{userId}/roles'
      operationId: 'getUserRoles'
      variables: GetUserRolesVariables
    }
  | {
      path: '/api/v3/users/{userId}'
      operationId: 'getUserDetail'
      variables: GetUserDetailVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/licenses'
      operationId: 'listOrgLicenses'
      variables: ListOrgLicensesVariables
    }
  | {
      path: '/api/v3/orgs/{orgId}/licenses/{licenseId}'
      operationId: 'getOrgLicense'
      variables: GetOrgLicenseVariables
    }
  | {
      path: '/api/v3/licenses/migration-eligibility/{userId}'
      operationId: 'getLicenseMigrationEligibility'
      variables: GetLicenseMigrationEligibilityVariables
    }
